import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import {
  RiMapPin2Line,
  RiPrinterLine,
  RiDeleteBin7Line,
  RiCompass3Line,
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiFileList3Line,
  RiMoneyDollarCircleLine,
  RiFilePaperLine,
  RiFlashlightLine,
  RiCameraLine,
  RiUpload2Line,
  RiStarFill,
  RiAwardLine,
  RiSearchLine,
  RiCloseFill,
  RiKey2Line,
  RiMailSendLine,
} from "react-icons/ri";
import { FaStar } from "react-icons/fa";
import { FiEdit2, FiPlus, FiUsers, FiExternalLink, FiFileText, FiPackage, FiCheckCircle, FiTrash2, FiAlertCircle, FiAlertTriangle, FiLock, FiDownload, FiImage, FiCalendar, FiClock } from "react-icons/fi";
import { MdOutlineCancel } from "react-icons/md";
import { LuHistory, LuFileSignature } from "react-icons/lu";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import api from "../../../../services/api";
import apiViaCep from "../../../../services/apiViaCep";
import logoImage from "../../../../assets/imagem_coringa.png";
import CertificateBackground from "../../../../assets/certificate-bg.png";
import {
  CertificateContainer,
  CertificateWrapper,
  BackgroundImage as CertificateBgImage,
  OverlayContent as CertificateOverlayContent,
  ParticipantName as CertificateParticipantName,
  CourseName as CertificateCourseName,
  DateText as CertificateDateText,
  DurationText as CertificateDurationText,
} from "../../../Fixiter/pages/Certificate/styles";
import { useAuth } from "../../../../hooks/AuthContext";
import { roles } from "../../../../utils/constants";
import { getLocatorPictureUrl } from "../../../../utils/locatorPicture";
import { showToast } from "../../../../components/CustomToast";
import { PrimaryButton } from "../../../../components/PrimaryButton";
import { SecondaryButton } from "../../../../components/SecondaryButton";
import { OutlinedInput } from "../../../../components/OutlinedInput";
import { FloatingSelect } from "../../../../components/FloatingSelect";
import { SwitchInput } from "../../../../components/SwitchInput";
import { FormModal } from "../../../../components/FormModal";
import { Table, Column, TableAction } from "../../../../components/Table";
import {
  formatCep,
  maskPhone,
  isValidCPF,
  isValidCNPJ,
  getLicenseeDisplayName,
} from "../../../../utils/formatters";
import { ISignature, useOnboard } from "../../../../hooks/OnboardContext";
import { IPlans } from "../../dtos";
import { Transactions } from "../../../Financial/components/Transactions";
import { AddFixcoinModal } from "../../../Licensee/components/AddFixcoinModal";
import {
  CustomerLocationPin,
  setCustomerAddressCache,
} from "../../components/CustomerLocationPin";
import { setCustomerPlanCache } from "../../components/CustomerPlanBadge";
import { getCustomerStatus } from "../../index";
import {
  CustomerInfoCell,
  CustomerName,
  StatusCell,
  DocumentText,
  PhoneText,
  SelectedFilterTag,
  SelectedFilterText,
  SelectedFilterRemoveButton,
} from "../../styles";
import { LockedFeatureIcon } from "../../../../components/LockedFeatureIcon";
import { Loading } from "../../../../components/Loading";
import ChangePasswordPopup from "../../../../components/ChangePasswordPopup";

import {
  PageContainer,
  FormWrapper,
  SectionBlock,
  SectionHeader,
  SectionTitleWrapper,
  SectionTitleRow,
  SectionTitle,
  EditingBadge,
  SectionSubtitle,
  BlockHeaderRight,
  PersonTypeSwitchWrapper,
  SwitchContainer,
  SwitchButton,
  InputGroup,
  Row,
  FlexInput,
  HeaderToggleWrapper,
  HeaderToggleLabel,
  SubSectionDivider,
  SubSectionTitle,
  SubSectionLine,
  FormCheckboxRow,
  AddressPreviewBox,
  AddressPreviewText,
  AddressSummaryBar,
  AddressSummaryLeft,
  AddressSummaryText,
  AddressAccordionToggleBtn,
  AddressFieldsWrapper,
  InlineCheckboxLabel,
  InlineCheckbox,
  PrintersContainer,
  PrinterAddRow,
  PrinterAddInputWrapper,
  SelectedPrintersList,
  PrinterChip,
  PrinterChipName,
  RemovePrinterButton,
  EmptyPrintersText,
  LoadingContainer,
  LoadingText,
  UsersTableWrapper,
  UserTableCell,
  UserAvatar,
  UserName,
  UserEmailCell,
  UserAccountBadge,
  UserPasswordActionBtn,
  EmptyUsersContainer,
  EmptyUsersText,
  ModalFormWrapper,
  ExpirationOutlinedContainer,
  ExpirationNotchedLabel,
  PlanTableWrapper,
  HistoryLinkButton,
  SignatureActionColumn,
  HistoryStatusBadge,
  TabsNavWrapper,
  TabsNavContainer,
  TabNavItem,
  TabBadge,
  HeaderTitleWrapper,
  HeaderTitleText,
  StatusPill,
  StatusBolinha,
  OnboardingGrid,
  OnboardingCard,
  OnboardingCardHeader,
  OnboardingCardTitle,
  OnboardingDetailsList,
  OnboardingDetailItem,
  VoltageSelectorWrapper,
  VoltageOption,
  ProposalDocumentButton,
  EmptyOnboardingBox,
  ProviderSearchWrapper,
  ProviderSearchContainer,
  ProviderSearchInput,
  ProviderSelectedFilterBadge,
  ProviderSearchButton,
  ProviderSearchSuggestionsList,
  ProviderSearchSuggestionItem,
  EmptySignatureNotice,
  EmptySignatureTitle,
  EmptySignatureDescription,
  WarningNotice,
  DangerDeleteNotice,
  ActionIconButton,
  LocatorPhotoSection,
  LocatorPhotoPreview,
  LocatorOfficialStarBadge,
  LocatorPhotoInfo,
  LocatorPhotoText,
  LocatorPhotoActions,
  LocatorPhotoUploadBtn,
  LocatorPhotoDeleteBtn,
  LocatorStarsGrid,
  LocatorStarCard,
  LocatorStarHeader,
  LocatorStarTitleGroup,
  LocatorStarIconBox,
  LocatorStarTitleTextWrapper,
  LocatorStarTitle,
  LocatorStarStatusBadge,
  LocatorStarDescription,
  CertificateClassBar,
  CertificateClassInfo,
  CertificateClassIconBox,
  CertificateClassTextGroup,
  CertificateClassLabel,
  CertificateClassName,
} from "./styles";

interface ICertificateResponse {
  available: boolean;
  message?: string;
  participant_name?: string;
  course_id?: string;
  course_name?: string;
  course_date?: string;
  duration_hours?: number | null;
  formatted_date?: string | null;
  formatted_duration?: string | null;
}

interface IOption {
  optionText: string;
  value: string | number;
}

interface SignatureSnapshotData {
  planId: string;
  startDate: string;
  endDate: string;
  noExpiration: boolean;
}

interface IProposalData {
  id?: string;
  total?: number | string;
  payment_method?: string;
  fixcoins_to_add?: number;
  status?: string;
  created_at?: string;
  proposal_document_url?: string;
  metadata?: any;
}

interface IOnboardingBill {
  id?: string;
  bill_value?: number | string;
  paid_ammount?: number | string;
  payment_method?: string;
  payment_situation?: string;
  type?: string;
  due_date?: string;
  payment_date?: string;
  referring_period?: string;
  coupon_id?: string;
}


interface IPerson {
  id: string;
  name: string;
  cpf?: string;
  cellphone?: string;
  expertise?: string;
  professional_number?: string;
  bp_register?: string;
  user?: {
    id?: string;
    role?: string;
    email?: string;
  };
}

interface RegistrationSnapshotData {
  name: string;
  companyName: string;
  personType: "FISICA" | "JURIDICA";
  documentNumber: string;
  email: string;
  phone: string;
  instagram: string;
  regCep: string;
  regStreet: string;
  regNumber: string;
  regNoNumber: boolean;
  regComplement: string;
  regNoComplement: boolean;
  regDistrict: string;
  regCity: string;
  regState: string;
}

interface LocatorSnapshotData {
  isPublic: boolean;
  useSameContact: boolean;
  locatorName: string;
  locatorPhone: string;
  pictureLink: string | null;
  useSameAddress: boolean;
  locCep: string;
  locStreet: string;
  locNumber: string;
  locNoNumber: boolean;
  locComplement: string;
  locNoComplement: boolean;
  locDistrict: string;
  locCity: string;
  locState: string;
}

const cpfMask = (value?: string | number | null) => {
  if (value === undefined || value === null) return "";
  return String(value)
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1")
    .substring(0, 14);
};

const cnpjMask = (value?: string | number | null) => {
  if (value === undefined || value === null) return "";
  return String(value)
    .replace(/\D/g, "")
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .substring(0, 18);
};

const formatPhoneInput = (val?: string | number | null): string => {
  if (val === undefined || val === null || val === "") return "";
  let digits = String(val).replace(/\D/g, "");
  if ((digits.length === 12 || digits.length === 13) && digits.startsWith("55")) {
    digits = digits.slice(2);
  }
  return maskPhone(digits);
};

const safeDateToInput = (val: any): string => {
  if (!val) return "";
  try {
    const d = new Date(val);
    if (isNaN(d.getTime())) return "";
    return d.toISOString().slice(0, 10);
  } catch {
    return "";
  }
};

const safeDateToISO = (val: any, isEndOfDay = false): string | undefined => {
  if (!val) return undefined;
  try {
    if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}$/.test(val.trim())) {
      const timePart = isEndOfDay ? "23:59:59.999Z" : "12:00:00.000Z";
      const d = new Date(`${val.trim()}T${timePart}`);
      if (!isNaN(d.getTime())) return d.toISOString();
    }
    const d = new Date(val);
    if (isNaN(d.getTime())) return undefined;
    return d.toISOString();
  } catch {
    return undefined;
  }
};

const safeFormatDatePtBr = (val: any, fallback = "-"): string => {
  if (!val) return fallback;
  try {
    const d = new Date(val);
    if (isNaN(d.getTime())) return fallback;
    return d.toLocaleDateString("pt-BR");
  } catch {
    return fallback;
  }
};

export type TabType =
  | "dados"
  | "certificado"
  | "assinatura"
  | "fixcoins"
  | "usuarios"
  | "locator"
  | "impressoras"
  | "provider";

export default function EditCustomer({
  isSelfProfile = false,
}: {
  isSelfProfile?: boolean;
} = {}) {
  const { id: routeId, options } = useParams<{ id: string; options?: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    user,
    reloadUser,
    setNavigationAction,
    activePlan: authActivePlan,
    isFixiter: authIsFixiter,
  } = useAuth();
  const {
    licensee,
    loadLicensee,
    activePlan: onboardActivePlan,
    isFixiter: onboardIsFixiter,
  } = useOnboard();

  const [resolvedSelfId, setResolvedSelfId] = useState<string>("");

  const id = isSelfProfile
    ? licensee?.id ||
      user?.person?.licensee?.id ||
      (user as any)?.licensee?.id ||
      (user as any)?.licensee_id ||
      resolvedSelfId ||
      routeId
    : routeId;

  const resolveTabFromOptions = useCallback(
    (opt?: string): TabType => {
      if (!opt) return "dados";
      const normalized = opt.toLowerCase();
      if (normalized === "locator" || normalized === "localizador") return "locator";
      if (normalized === "certificate" || normalized === "certificado") return "certificado";
      if (normalized === "assinatura" || normalized === "signature") return "assinatura";
      if (normalized === "users" || normalized === "usuarios") return "usuarios";
      if (normalized === "printers" || normalized === "impressoras") return "impressoras";
      return "dados";
    },
    []
  );

  const [activeTab, setActiveTab] = useState<TabType>(() =>
    resolveTabFromOptions(options)
  );

  useEffect(() => {
    if (isSelfProfile && options) {
      setActiveTab(resolveTabFromOptions(options));
    }
  }, [isSelfProfile, options, resolveTabFromOptions]);
  const tabsNavRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const dragStartX = useRef(0);
  const dragScrollLeft = useRef(0);
  const hasDragged = useRef(false);

  const checkTabsScroll = useCallback(() => {
    const el = tabsNavRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setCanScrollLeft(scrollLeft > 2);
    setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 2);
  }, []);

  useEffect(() => {
    const el = tabsNavRef.current;
    if (!el) return;
    checkTabsScroll();

    const handleResize = () => checkTabsScroll();
    window.addEventListener("resize", handleResize);
    el.addEventListener("scroll", checkTabsScroll, { passive: true });

    return () => {
      window.removeEventListener("resize", handleResize);
      el.removeEventListener("scroll", checkTabsScroll);
    };
  }, [checkTabsScroll]);

  useEffect(() => {
    const el = tabsNavRef.current;
    if (!el) return;
    const activeEl = el.querySelector<HTMLElement>('[data-active="true"]');
    if (activeEl) {
      activeEl.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }
  }, [activeTab]);

  const handleMouseDown = (e: React.MouseEvent) => {
    const el = tabsNavRef.current;
    if (!el) return;
    setIsDragging(true);
    hasDragged.current = false;
    dragStartX.current = e.pageX - el.offsetLeft;
    dragScrollLeft.current = el.scrollLeft;
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging) return;
    const el = tabsNavRef.current;
    if (!el) return;
    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    const walk = (x - dragStartX.current) * 1.5;
    if (Math.abs(walk) > 4) {
      hasDragged.current = true;
    }
    el.scrollLeft = dragScrollLeft.current - walk;
  };

  const handleMouseUpOrLeave = () => {
    setIsDragging(false);
  };

  const [fixcoinsBalance, setFixcoinsBalance] = useState<number>(0);
  const [isAddFixcoinModalOpen, setIsAddFixcoinModalOpen] = useState(false);
  const [fixcoinsReloadKey, setFixcoinsReloadKey] = useState(0);

  const fetchFixcoinsBalance = useCallback(async () => {
    if (!id) return;
    try {
      const res = await api.get(`/transactions/fixcoin/${id}`);
      setFixcoinsBalance(
        typeof res.data === "number" ? res.data : Number(res.data) || 0
      );
    } catch (err) {
      console.error("Erro ao buscar saldo de FixCoins:", err);
    }
  }, [id]);

  const handleFixcoinAdded = useCallback(() => {
    setIsAddFixcoinModalOpen(false);
    fetchFixcoinsBalance();
    setFixcoinsReloadKey((prev) => prev + 1);
  }, [fetchFixcoinsBalance]);

  const [loading, setLoading] = useState(true);

  // --- BLOCK 1: DADOS DE FATURAMENTO ---
  const [isEditingRegistration, setIsEditingRegistration] = useState(false);
  const [savingRegistration, setSavingRegistration] = useState(false);
  const registrationSnapshot = useRef<RegistrationSnapshotData | null>(null);
  const [registrationErrors, setRegistrationErrors] = useState<{
    customerName?: string;
    companyName?: string;
    documentNumber?: string;
    email?: string;
    phone?: string;
  }>({});

  const [headerDisplayName, setHeaderDisplayName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [personType, setPersonType] = useState<"FISICA" | "JURIDICA">("FISICA");
  const [documentNumber, setDocumentNumber] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [instagram, setInstagram] = useState("");
  const [isFixpoint, setIsFixpoint] = useState(false);
  const [isTest, setIsTest] = useState(false);
  const [savingSwitchTest, setSavingSwitchTest] = useState(false);
  const [customerSituation, setCustomerSituation] = useState("operational");
  const [isBlocked, setIsBlocked] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);
  const [providerId, setProviderId] = useState("");
  const [providerOptions, setProviderOptions] = useState<IOption[]>([]);

  // Endereço de faturamento
  const [isRegAddressExpanded, setIsRegAddressExpanded] = useState(false);
  const [regAddressId, setRegAddressId] = useState<string | null>(null);
  const [regCep, setRegCep] = useState("");
  const [regStreet, setRegStreet] = useState("");
  const [regNumber, setRegNumber] = useState("");
  const [regNoNumber, setRegNoNumber] = useState(false);
  const [regComplement, setRegComplement] = useState("");
  const [regNoComplement, setRegNoComplement] = useState(false);
  const [regDistrict, setRegDistrict] = useState("");
  const [regCity, setRegCity] = useState("");
  const [regState, setRegState] = useState("");
  const [searchingRegCep, setSearchingRegCep] = useState(false);

  // --- BLOCK: ASSINATURA ---
  const [isEditingSignature, setIsEditingSignature] = useState(false);
  const [savingSignature, setSavingSignature] = useState(false);
  const signatureSnapshot = useRef<SignatureSnapshotData | null>(null);

  const [activePlans, setActivePlans] = useState<IPlans[]>([]);
  const [currentSignature, setCurrentSignature] = useState<ISignature | null>(null);
  const [allSignatures, setAllSignatures] = useState<ISignature[]>([]);

  const [selectedPlanId, setSelectedPlanId] = useState("");
  const [signatureStartDate, setSignatureStartDate] = useState("");
  const [signatureEndDate, setSignatureEndDate] = useState("");
  const [noExpiration, setNoExpiration] = useState(false);

  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [planDetails, setPlanDetails] = useState<any>(null);

  // Estado para Adicionar Nova Assinatura diretamente na tela
  const [isAddingSignature, setIsAddingSignature] = useState(false);

  // Estados para Exclusão Física de Assinatura
  const [signatureToDelete, setSignatureToDelete] = useState<ISignature | null>(null);
  const [deleteConfirmationText, setDeleteConfirmationText] = useState("");
  const [isDeletingSignature, setIsDeletingSignature] = useState(false);

  // Estados para Cancelamento de Assinatura
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [cancelConfirmationText, setCancelConfirmationText] = useState("");
  const [isCancellingSubscription, setIsCancellingSubscription] = useState(false);

  const activePlan =
    planDetails ||
    currentSignature?.plan ||
    (currentSignature as any)?.plans ||
    allSignatures[0]?.plan ||
    (allSignatures[0] as any)?.plans ||
    activePlans.find((p) => String(p.id) === String(selectedPlanId)) ||
    (isSelfProfile ? onboardActivePlan || authActivePlan : undefined);

  const isFixiter = useMemo(() => {
    if (activePlan && typeof activePlan.has_printer === "boolean") {
      return activePlan.has_printer === false;
    }
    if (isSelfProfile) {
      const ctxPlan = onboardActivePlan || authActivePlan;
      if (ctxPlan && typeof ctxPlan.has_printer === "boolean") {
        return ctxPlan.has_printer === false;
      }
      return Boolean(onboardIsFixiter || authIsFixiter);
    }
    return (
      location.pathname.includes("fixiter") ||
      (location.state as any)?.customerType === "fixiters"
    );
  }, [
    activePlan,
    isSelfProfile,
    onboardActivePlan,
    authActivePlan,
    onboardIsFixiter,
    authIsFixiter,
    location,
  ]);

  const isFixiterForCertificate = useMemo(() => {
    if (isSelfProfile) {
      return Boolean(isFixiter || user?.role === roles.fixiter);
    }
    return Boolean(
      isFixiter ||
        location.pathname.includes("fixiter") ||
        (location.state as any)?.customerType === "fixiters"
    );
  }, [isSelfProfile, isFixiter, user?.role, location]);

  const [lockedTabModal, setLockedTabModal] = useState<TabType | null>(null);
  const [isGoldStarModalOpen, setIsGoldStarModalOpen] = useState(false);

  useEffect(() => {
    if (activeTab === "impressoras" && isSelfProfile && isFixiter) {
      setActiveTab("dados");
    }
  }, [activeTab, isFixiter, isSelfProfile]);

  const customerType = isFixiter ? "fixiters" : "licensees";

  // --- BLOCK: ADESÃO & EQUIPAMENTOS ---
  const [proposalData, setProposalData] = useState<IProposalData | null>(null);
  const [onboardingBill, setOnboardingBill] = useState<IOnboardingBill | null>(null);
  const [customerMetadata, setCustomerMetadata] = useState<Record<string, any>>({});
  const [equipmentVoltage, setEquipmentVoltage] = useState<"110v" | "220v" | "">("");
  const [wantsHeatGun, setWantsHeatGun] = useState<boolean>(true);
  const [orderedInitialKit, setOrderedInitialKit] = useState<boolean>(false);
  const [isEditingOnboarding, setIsEditingOnboarding] = useState(false);
  const [savingOnboarding, setSavingOnboarding] = useState(false);
  const onboardingSnapshot = useRef<{
    voltage: "110v" | "220v" | "";
    wantsHeatGun: boolean;
  }>({
    voltage: "",
    wantsHeatGun: true,
  });

  // --- BLOCK 2: USUÁRIOS (PERSON) ---
  const [persons, setPersons] = useState<IPerson[]>([]);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [editingPerson, setEditingPerson] = useState<IPerson | null>(null);
  const [savingPerson, setSavingPerson] = useState(false);

  const [modalPersonName, setModalPersonName] = useState("");
  const [modalPersonCellphone, setModalPersonCellphone] = useState("");
  const [modalPersonEmail, setModalPersonEmail] = useState("");
  const [modalPersonExpertise, setModalPersonExpertise] = useState("");
  const [modalPersonCouncilNumber, setModalPersonCouncilNumber] = useState("");
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const [changePasswordUserId, setChangePasswordUserId] = useState("");
  const [sendingResetPersonId, setSendingResetPersonId] = useState<string | null>(null);

  // --- BLOCK: CERTIFICADO (FIXITER) ---
  const certificateRef = useRef<HTMLDivElement>(null);
  const [isDownloadingCertificatePDF, setIsDownloadingCertificatePDF] = useState(false);
  const [isDownloadingCertificateImage, setIsDownloadingCertificateImage] = useState(false);
  const [certificateData, setCertificateData] = useState<ICertificateResponse | null>(null);
  const [loadingCertificate, setLoadingCertificate] = useState(false);
  const [hasCourseFromCertificateApi, setHasCourseFromCertificateApi] = useState<boolean>(false);
  const [linkedCourseId, setLinkedCourseId] = useState<string>("");
  const [linkedCourseName, setLinkedCourseName] = useState<string>("");
  const [linkedCourseDate, setLinkedCourseDate] = useState<string>("");
  const [linkedCourseDuration, setLinkedCourseDuration] = useState<number | null | undefined>(undefined);
  const [isCourseModalOpen, setIsCourseModalOpen] = useState(false);
  const [availableCourses, setAvailableCourses] = useState<any[]>([]);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState<string>("");
  const [savingCourseLink, setSavingCourseLink] = useState(false);

  const persistLinkedCourse = useCallback(
    (
      courseInfo: {
        id?: string;
        name?: string;
        date?: string;
        duration_hours?: number | null;
      },
      customTargetId?: string
    ) => {
      const resolvedTarget = customTargetId || id;
      if (!resolvedTarget) return;
      const cacheKey = `fixiter_course_${resolvedTarget}`;
      try {
        const existingRaw = localStorage.getItem(cacheKey);
        const existing = existingRaw ? JSON.parse(existingRaw) : {};
        const merged = {
          id: courseInfo.id !== undefined ? courseInfo.id : existing.id || "",
          name:
            courseInfo.name !== undefined ? courseInfo.name : existing.name || "",
          date:
            courseInfo.date !== undefined ? courseInfo.date : existing.date || "",
          duration_hours:
            courseInfo.duration_hours !== undefined
              ? courseInfo.duration_hours
              : existing.duration_hours,
        };
        if (merged.id || merged.name) {
          localStorage.setItem(cacheKey, JSON.stringify(merged));
        }
      } catch {
        // ignore
      }
    },
    [id]
  );

  useEffect(() => {
    setHasCourseFromCertificateApi(false);
    if (isSelfProfile || !id) {
      setLinkedCourseId("");
      setLinkedCourseName("");
      setLinkedCourseDate("");
      setLinkedCourseDuration(undefined);
      return;
    }
    const cacheKey = `fixiter_course_${id}`;
    try {
      const raw = localStorage.getItem(cacheKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        setLinkedCourseId(parsed.id ? String(parsed.id) : "");
        setLinkedCourseName(parsed.name ? String(parsed.name) : "");
        setLinkedCourseDate(parsed.date ? String(parsed.date) : "");
        setLinkedCourseDuration(
          parsed.duration_hours !== undefined ? parsed.duration_hours : undefined
        );
        return;
      }
    } catch {
      // ignore
    }
    setLinkedCourseId("");
    setLinkedCourseName("");
    setLinkedCourseDate("");
    setLinkedCourseDuration(undefined);
  }, [id, isSelfProfile]);

  const certificateParticipantName =
    certificateData?.participant_name ||
    (isSelfProfile ? user?.person?.name : undefined) ||
    persons[0]?.name ||
    headerDisplayName || customerName ||
    "Aluno Fix it";

  const extractAndApplyCourseFields = useCallback(
    (payload: any) => {
      if (!payload || typeof payload !== "object") return;
      const nestedCourse =
        payload.course ||
        payload.course_licensee?.course ||
        payload.courseLicensee?.course;
      const cId =
        payload.course_id ||
        payload.courseId ||
        nestedCourse?.id ||
        nestedCourse?.course_id ||
        "";
      const cName =
        payload.course_name ||
        payload.courseName ||
        nestedCourse?.name ||
        nestedCourse?.course_name ||
        "";
      const cDate =
        payload.course_date ||
        payload.courseDate ||
        nestedCourse?.date ||
        nestedCourse?.course_date ||
        "";
      const cDuration =
        payload.duration_hours !== undefined
          ? payload.duration_hours
          : nestedCourse?.duration_hours;

      if (cId) setLinkedCourseId(String(cId));
      if (cName) setLinkedCourseName(String(cName));
      if (cDate) setLinkedCourseDate(String(cDate));
      if (cDuration !== undefined) setLinkedCourseDuration(cDuration);

      if (cId || cName || cDate || cDuration !== undefined) {
        persistLinkedCourse({
          id: cId ? String(cId) : undefined,
          name: cName ? String(cName) : undefined,
          date: cDate ? String(cDate) : undefined,
          duration_hours: cDuration,
        });
      }
    },
    [persistLinkedCourse]
  );

  const fetchCertificateData = useCallback(async () => {
    if (!isSelfProfile && !id) return;
    setLoadingCertificate(true);

    const checkLinkedFromPayload = (d: any): boolean => {
      if (!d || typeof d !== "object") return false;
      const msg = String(d.message || "").toLowerCase();
      if (
        msg.includes("nenhuma turma") ||
        msg.includes("não possui turma") ||
        msg.includes("nao possui turma") ||
        msg.includes("sem turma") ||
        msg.includes("não vinculado") ||
        msg.includes("nao vinculado") ||
        msg.includes("não está vinculado") ||
        msg.includes("nao esta vinculado") ||
        msg.includes("não encontrado") ||
        msg.includes("nao encontrado")
      ) {
        return false;
      }
      return Boolean(
        d.available === true ||
          d.course_id ||
          d.courseId ||
          d.course_name ||
          d.courseName ||
          d.course?.id ||
          d.course?.name ||
          msg.includes("treinamento ao vivo") ||
          msg.includes("após a conclusão") ||
          msg.includes("apos a conclusao") ||
          msg.includes("estará disponível") ||
          msg.includes("estara disponivel")
      );
    };

    const clearStaleCourseState = () => {
      if (isSelfProfile) {
        setLinkedCourseId("");
        setLinkedCourseName("");
        setLinkedCourseDate("");
        setLinkedCourseDuration(undefined);
      }
      if (id) {
        try {
          localStorage.removeItem(`fixiter_course_${id}`);
        } catch {
          // ignore
        }
      }
    };

    try {
      const endpoint = isSelfProfile
        ? "/courses/certificate/me"
        : `/courses/certificate/${id}`;
      const res = await api.get(endpoint);
      const data: ICertificateResponse = res.data;
      setCertificateData(data);
      const isLinked = checkLinkedFromPayload(data);
      setHasCourseFromCertificateApi(isLinked);
      if (isLinked) {
        extractAndApplyCourseFields(data);
      } else {
        clearStaleCourseState();
      }
    } catch (err: any) {
      const errData = err?.response?.data;
      const isLinkedInErr = checkLinkedFromPayload(errData);
      setHasCourseFromCertificateApi(isLinkedInErr);
      if (isLinkedInErr) {
        extractAndApplyCourseFields(errData);
      } else {
        clearStaleCourseState();
      }
      setCertificateData({
        available: false,
        message:
          errData?.message ||
          "O certificado estará disponível após a conclusão do treinamento ao vivo.",
      });
    } finally {
      setLoadingCertificate(false);
    }
  }, [isSelfProfile, id, extractAndApplyCourseFields]);

  const fetchAvailableCourses = useCallback(async () => {
    if (isSelfProfile) return;
    setLoadingCourses(true);
    try {
      const res = await api.get("/courses");
      const raw = res.data;
      const list = Array.isArray(raw)
        ? raw
        : Array.isArray(raw?.courses)
        ? raw.courses
        : Array.isArray(raw?.data)
        ? raw.data
        : [];
      setAvailableCourses(list);
    } catch {
      // ignora erro silenciosamente
    } finally {
      setLoadingCourses(false);
    }
  }, [isSelfProfile]);

  const hasFetchedCoursesRef = useRef(false);
  const hasCheckedSelfCourseRef = useRef(false);

  useEffect(() => {
    hasCheckedSelfCourseRef.current = false;
    if (!isSelfProfile) {
      hasFetchedCoursesRef.current = false;
    }
  }, [id, isSelfProfile]);

  useEffect(() => {
    if (activeTab === "certificado" && isFixiterForCertificate) {
      fetchCertificateData();
      if (!isSelfProfile && !hasFetchedCoursesRef.current) {
        hasFetchedCoursesRef.current = true;
        fetchAvailableCourses();
      }
    }
  }, [
    activeTab,
    isFixiterForCertificate,
    isSelfProfile,
    fetchCertificateData,
    fetchAvailableCourses,
  ]);

  useEffect(() => {
    if (
      isSelfProfile &&
      isFixiterForCertificate &&
      !hasCheckedSelfCourseRef.current
    ) {
      hasCheckedSelfCourseRef.current = true;
      if (activeTab !== "certificado") {
        fetchCertificateData();
      }
    }
  }, [
    isSelfProfile,
    isFixiterForCertificate,
    activeTab,
    fetchCertificateData,
  ]);

  const resolvedLinkedCourse = useMemo(() => {
    let cId = linkedCourseId || certificateData?.course_id || "";
    let fromList = cId
      ? availableCourses.find((c) => String(c.id) === String(cId))
      : linkedCourseName
      ? availableCourses.find((c) => String(c.name) === String(linkedCourseName))
      : null;

    if (!fromList && id && availableCourses.length > 0) {
      fromList =
        availableCourses.find((c) => {
          const participants =
            c.licensees || c.course_licensees || c.courseLicensees || c.participants;
          if (!Array.isArray(participants)) return false;
          return participants.some(
            (p: any) =>
              String(p?.id) === String(id) ||
              String(p?.licensee_id) === String(id) ||
              String(p?.licensee?.id) === String(id)
          );
        }) || null;
      if (fromList?.id && !cId) {
        cId = String(fromList.id);
      }
    }

    const name =
      fromList?.name ||
      linkedCourseName ||
      certificateData?.course_name ||
      "";
    const date =
      fromList?.date ||
      linkedCourseDate ||
      certificateData?.course_date ||
      "";
    const duration =
      fromList?.duration_hours !== undefined
        ? fromList.duration_hours
        : linkedCourseDuration !== undefined
        ? linkedCourseDuration
        : certificateData?.duration_hours;
    return {
      id: cId,
      name,
      date,
      duration,
    };
  }, [
    id,
    linkedCourseId,
    linkedCourseName,
    linkedCourseDate,
    linkedCourseDuration,
    certificateData,
    availableCourses,
  ]);

  const hasLinkedCourse = isSelfProfile
    ? Boolean(hasCourseFromCertificateApi)
    : Boolean(
        resolvedLinkedCourse.id ||
          resolvedLinkedCourse.name ||
          hasCourseFromCertificateApi
      );

  const canShowCertificateTab =
    isFixiterForCertificate && (!isSelfProfile || hasLinkedCourse);

  useEffect(() => {
    if (activeTab !== "certificado") return;
    if (!isFixiterForCertificate) {
      setActiveTab("dados");
      return;
    }
    if (
      isSelfProfile &&
      !loadingCertificate &&
      certificateData !== null &&
      !hasLinkedCourse
    ) {
      setActiveTab("dados");
    }
  }, [
    activeTab,
    isFixiterForCertificate,
    isSelfProfile,
    loadingCertificate,
    certificateData,
    hasLinkedCourse,
  ]);

  const handleOpenCourseModal = () => {
    setSelectedCourseId(resolvedLinkedCourse.id || "");
    setIsCourseModalOpen(true);
    if (availableCourses.length === 0) {
      fetchAvailableCourses();
    }
  };

  const handleSaveCourseLink = async () => {
    if (!id) return;
    if (!selectedCourseId) {
      showToast({
        type: "warning",
        message: "Selecione uma turma para vincular.",
      });
      return;
    }
    setSavingCourseLink(true);
    try {
      const res = await api.put(`/courses/licensees/${id}`, {
        course_id: selectedCourseId,
      });
      const updatedData = res.data;
      const matchedCourse = availableCourses.find(
        (c) => String(c.id) === String(selectedCourseId)
      );
      const apiCourseObj =
        updatedData?.course ||
        updatedData?.course_licensee?.course ||
        updatedData?.courseLicensee?.course;
      const resolvedId = String(selectedCourseId);
      const resolvedName = String(
        matchedCourse?.name ||
          apiCourseObj?.name ||
          updatedData?.course_name ||
          ""
      );
      const resolvedDate = String(
        matchedCourse?.date ||
          apiCourseObj?.date ||
          updatedData?.course_date ||
          ""
      );
      const resolvedDuration =
        matchedCourse?.duration_hours !== undefined
          ? matchedCourse.duration_hours
          : apiCourseObj?.duration_hours !== undefined
          ? apiCourseObj.duration_hours
          : updatedData?.duration_hours;

      setLinkedCourseId(resolvedId);
      setLinkedCourseName(resolvedName);
      setLinkedCourseDate(resolvedDate);
      setLinkedCourseDuration(resolvedDuration);
      setHasCourseFromCertificateApi(true);

      persistLinkedCourse({
        id: resolvedId,
        name: resolvedName,
        date: resolvedDate,
        duration_hours: resolvedDuration,
      });

      showToast({
        type: "success",
        message: "Turma vinculada com sucesso!",
      });
      setIsCourseModalOpen(false);
      await fetchCertificateData();
    } catch (error: any) {
      showToast({
        type: "error",
        message:
          error?.response?.data?.message ||
          "Ocorreu um erro ao atualizar a turma do Fixiter.",
      });
    } finally {
      setSavingCourseLink(false);
    }
  };

  const handleDownloadCertificatePDF = async () => {
    if (!certificateRef.current) return;
    try {
      setIsDownloadingCertificatePDF(true);
      const canvas = await html2canvas(certificateRef.current, {
        scale: 2,
        useCORS: true,
        logging: false,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(
        `Certificado_Fix_it_${certificateParticipantName.replace(/\s+/g, "_") || "Aluno"}.pdf`
      );
    } catch (error) {
      console.error("Erro ao gerar o PDF do certificado:", error);
    } finally {
      setIsDownloadingCertificatePDF(false);
    }
  };

  const handleDownloadCertificateImage = async () => {
    if (!certificateRef.current) return;
    try {
      setIsDownloadingCertificateImage(true);
      const canvas = await html2canvas(certificateRef.current, {
        scale: 3,
        useCORS: true,
        logging: false,
      });

      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const link = document.createElement("a");
      link.href = imgData;
      link.download = `Certificado_Fix_it_${
        certificateParticipantName.replace(/\s+/g, "_") || "Aluno"
      }.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Erro ao gerar a Imagem do certificado:", error);
    } finally {
      setIsDownloadingCertificateImage(false);
    }
  };

  // --- BLOCK 3: DADOS DO LOCALIZADOR ---
  const [isEditingLocator, setIsEditingLocator] = useState(false);
  const [savingLocator, setSavingLocator] = useState(false);
  const locatorSnapshot = useRef<LocatorSnapshotData | null>(null);

  const [isPublic, setIsPublic] = useState(true);
  const [savingSwitchPublic, setSavingSwitchPublic] = useState(false);
  const [useSameContact, setUseSameContact] = useState(true);
  const [locatorName, setLocatorName] = useState("");
  const [locatorPhone, setLocatorPhone] = useState("");
  const [locatorPictureLink, setLocatorPictureLink] = useState<string | null>(null);
  const [uploadingLocatorPic, setUploadingLocatorPic] = useState(false);
  const [removingLocatorPic, setRemovingLocatorPic] = useState(false);
  const locatorFileInputRef = useRef<HTMLInputElement | null>(null);

  const [useSameAddress, setUseSameAddress] = useState(true);
  const [locAddressId, setLocAddressId] = useState<string | null>(null);
  const [locCep, setLocCep] = useState("");
  const [locStreet, setLocStreet] = useState("");
  const [locNumber, setLocNumber] = useState("");
  const [locNoNumber, setLocNoNumber] = useState(false);
  const [locComplement, setLocComplement] = useState("");
  const [locNoComplement, setLocNoComplement] = useState(false);
  const [locDistrict, setLocDistrict] = useState("");
  const [locCity, setLocCity] = useState("");
  const [locState, setLocState] = useState("");
  const [searchingLocCep, setSearchingLocCep] = useState(false);

  // --- BLOCK 4: IMPRESSORAS VINCULADAS ---
  const [isEditingPrinters, setIsEditingPrinters] = useState(false);
  const [savingPrinters, setSavingPrinters] = useState(false);
  const printersSnapshot = useRef<IOption[]>([]);

  const [allPrinters, setAllPrinters] = useState<IOption[]>([]);
  const [selectedPrinters, setSelectedPrinters] = useState<IOption[]>([]);
  const [printerToAdd, setPrinterToAdd] = useState("");

  const [savingSwitchFixpoint, setSavingSwitchFixpoint] = useState(false);

  // --- BLOCK 5: FIXPOINT / PROVEDOR (EXCLUSIVO FIXITER) ---
  const [isEditingProvider, setIsEditingProvider] = useState(false);
  const [savingProvider, setSavingProvider] = useState(false);
  const providerSnapshot = useRef<string>("");
  const [providersList, setProvidersList] = useState<any[]>([]);
  const [providerSearchTerm, setProviderSearchTerm] = useState("");
  const [providerSuggestions, setProviderSuggestions] = useState<any[]>([]);
  const [showProviderSuggestions, setShowProviderSuggestions] = useState(false);
  const providerSuggestionsRef = useRef<HTMLDivElement>(null);
  const [fetchedProviderDetails, setFetchedProviderDetails] = useState<any | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        providerSuggestionsRef.current &&
        !providerSuggestionsRef.current.contains(event.target as Node)
      ) {
        setShowProviderSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isEditingProvider || !showProviderSuggestions) return;

    const term = providerSearchTerm.trim();
    if (term.length < 2) {
      setProviderSuggestions([]);
      return;
    }

    let isCancelled = false;
    const timeoutId = setTimeout(async () => {
      const lowerTerm = term.toLowerCase();
      const localMatches = providersList.filter(
        (p) =>
          p &&
          String(p.id) !== String(id) &&
          ((p.name && String(p.name).toLowerCase().includes(lowerTerm)) ||
            (p.company_name && String(p.company_name).toLowerCase().includes(lowerTerm)) ||

            (p.document_number && String(p.document_number).includes(term)) ||
            (p.documentNumber && String(p.documentNumber).includes(term)))
      );

      try {
        const res = await api.get("/licensees/search", { params: { term } });
        if (isCancelled) return;
        const apiItems = Array.isArray(res.data) ? res.data.filter(Boolean) : [];
        const mergedMap = new Map<string, any>();

        for (const item of localMatches) {
          mergedMap.set(String(item.id), item);
        }
        for (const item of apiItems) {
          if (!item || item.id == null || String(item.id) === String(id)) continue;
          const existing = mergedMap.get(String(item.id));
          mergedMap.set(String(item.id), existing ? { ...item, ...existing } : item);
        }

        setProviderSuggestions(Array.from(mergedMap.values()));
      } catch {
        if (!isCancelled) {
          setProviderSuggestions(localMatches);
        }
      }
    }, 300);

    return () => {
      isCancelled = true;
      clearTimeout(timeoutId);
    };
  }, [providerSearchTerm, isEditingProvider, showProviderSuggestions, providersList, id]);

  const printersLoadedRef = useRef(false);
  const providersLoadedRef = useRef(false);

  useEffect(() => {
    if (isSelfProfile || activeTab !== "impressoras" || printersLoadedRef.current) {
      return;
    }
    let isCancelled = false;
    printersLoadedRef.current = true;
    api
      .get("/printers")
      .then((res) => {
        if (isCancelled || !Array.isArray(res.data)) return;
        setAllPrinters(
          res.data
            .filter((p: any) => p && p.id != null)
            .map((p: any) => ({
              value: p.id,
              optionText: p.name || "",
            }))
        );
      })
      .catch(() => {
        printersLoadedRef.current = false;
      });
    return () => {
      isCancelled = true;
    };
  }, [isSelfProfile, activeTab]);

  useEffect(() => {
    if (isSelfProfile || activeTab !== "provider" || providersLoadedRef.current) {
      return;
    }
    let isCancelled = false;
    providersLoadedRef.current = true;
    api
      .get("/licensees?has_printer=true")
      .then((res) => {
        if (isCancelled || !res.data) return;
        const rawList: any[] = Array.isArray(res.data?.data)
          ? res.data.data
          : Array.isArray(res.data)
          ? res.data
          : [];
        const pList = rawList.filter((p: any) => p && p.id != null);
        setProvidersList(pList);
        setProviderOptions(
          pList
            .filter((p: any) => String(p.id) !== String(id))
            .map((p: any) => ({
              value: p.id,
              optionText: `${getLicenseeDisplayName(p, "Licenciado")}${
                p.city ? ` (${p.city}/${p.state})` : ""
              }`,
            }))
        );
      })
      .catch(() => {
        providersLoadedRef.current = false;
      });
    return () => {
      isCancelled = true;
    };
  }, [isSelfProfile, activeTab, id]);

  useEffect(() => {
    if (!providerId) {
      setFetchedProviderDetails(null);
      return;
    }
    if (isSelfProfile || activeTab !== "provider") {
      return;
    }

    let isCancelled = false;
    (async () => {
      try {
        const [licRes, addrRes] = await Promise.allSettled([
          api.get(`/licensees/${providerId}`),
          api.get(`/address/all/${providerId}`),
        ]);
        if (isCancelled) return;

        const licData =
          licRes.status === "fulfilled" && licRes.value?.data
            ? licRes.value.data
            : {};
        const addrList =
          addrRes.status === "fulfilled" && Array.isArray(addrRes.value?.data)
            ? addrRes.value.data.filter(Boolean)
            : [];
        const mainAddr =
          addrList.find((a: any) => Boolean(a.company_address)) ||
          addrList.find((a: any) => !a.is_public) ||
          addrList[0] ||
          {};

        setFetchedProviderDetails((prev: any) => ({
          ...(prev && String(prev.id) === String(providerId) ? prev : {}),
          ...licData,
          id: providerId,
          addresses:
            addrList.length > 0
              ? addrList
              : licData.addresses || prev?.addresses,
          city: mainAddr.city || licData.city || prev?.city || "",
          state: mainAddr.state || licData.state || prev?.state || "",
        }));
      } catch {
        // Ignora silenciosamente se falhar o enriquecimento
      }
    })();

    return () => {
      isCancelled = true;
    };
  }, [providerId, isSelfProfile, activeTab]);

  const selectedProviderInfo = useMemo(() => {
    if (!providerId) return null;
    const fromList =
      providersList.find((p) => String(p.id) === String(providerId)) || null;
    const fromFetched =
      fetchedProviderDetails &&
      String(fetchedProviderDetails.id) === String(providerId)
        ? fetchedProviderDetails
        : null;
    if (!fromList && !fromFetched) return null;
    return {
      ...(fromList || {}),
      ...(fromFetched || {}),
    };
  }, [providerId, providersList, fetchedProviderDetails]);

  useEffect(() => {
    if (!isEditingProvider) {
      setProviderSearchTerm(
        selectedProviderInfo
          ? getLicenseeDisplayName(selectedProviderInfo)
          : ""
      );
    }
  }, [selectedProviderInfo, isEditingProvider]);

  const handleSelectProviderSuggestion = useCallback((suggestion: any) => {
    setProviderId(String(suggestion.id));
    setProviderSearchTerm(getLicenseeDisplayName(suggestion));
    setFetchedProviderDetails(suggestion);
    setShowProviderSuggestions(false);
  }, []);

  const handleClearProvider = useCallback(() => {
    setProviderId("");
    setProviderSearchTerm("");
    setFetchedProviderDetails(null);
    setProviderSuggestions([]);
    setShowProviderSuggestions(false);
  }, []);

  const handleCancelProvider = useCallback(() => {
    const snapId = providerSnapshot.current;
    setProviderId(snapId);
    setShowProviderSuggestions(false);
    setIsEditingProvider(false);
    if (!snapId) {
      setProviderSearchTerm("");
    } else {
      const snapProvider = providersList.find(
        (p) => String(p.id) === String(snapId)
      );
      if (snapProvider) {
        setProviderSearchTerm(getLicenseeDisplayName(snapProvider));
      }
    }
  }, [providersList]);

  const handleSaveProvider = useCallback(async () => {
    if (!id) return;
    setSavingProvider(true);
    try {
      await api.put("/licensees/provider", {
        licensee_id: id,
        provider_id: providerId || null,
      });
      providerSnapshot.current = providerId;
      setIsEditingProvider(false);
      setShowProviderSuggestions(false);
      showToast({
        type: "success",
        message: "FixPoint (Provedor) atualizado com sucesso!",
      });
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.message || "Erro ao atualizar FixPoint (Provedor).";
      showToast({
        type: "error",
        message: errorMsg,
      });
    } finally {
      setSavingProvider(false);
    }
  }, [id, providerId]);

  const providerColumns: Column<any>[] = useMemo(
    () => [
      {
        key: "identification",
        header: "Licenciado",
        width: "28%",
        render: (row) => {
          const { color: statusColor } = getCustomerStatus(row);
          return (
            <CustomerInfoCell>
              <CustomerName color={statusColor}>
                {getLicenseeDisplayName(row, "-")}
              </CustomerName>
              <CustomerLocationPin customer={row} />
            </CustomerInfoCell>
          );
        },
      },
      {
        key: "status",
        header: "Status",
        width: "16%",
        render: (row) => {
          const { label, color } = getCustomerStatus(row);
          return (
            <StatusCell color={color}>
              <StatusBolinha color={color} />
              {label}
            </StatusCell>
          );
        },
      },
      {
        key: "document_number",
        header: "Documento",
        width: "20%",
        render: (row) => {
          const rawDoc = String(
            row.document_number || row.documentNumber || ""
          ).replace(/\D/g, "");
          const formattedDoc = rawDoc
            ? rawDoc.length <= 11
              ? cpfMask(rawDoc)
              : cnpjMask(rawDoc)
            : "-";
          return <DocumentText>{formattedDoc}</DocumentText>;
        },
      },
      {
        key: "phone",
        header: "Contato",
        width: "18%",
        render: (row) => {
          const phoneVal = row.phone || row.cellphone || "";
          return (
            <PhoneText>
              {phoneVal ? formatPhoneInput(phoneVal) : "-"}
            </PhoneText>
          );
        },
      },
      {
        key: "printers",
        header: "Impressoras 3D",
        width: "18%",
        render: (row) => {
          const count = Array.isArray(row.printers) ? row.printers.length : 0;
          return (
            <DocumentText>
              {count > 0 ? `${count} impressora(s)` : "-"}
            </DocumentText>
          );
        },
      },
    ],
    []
  );

  // Toggle Visível no Localizador
  const handleTogglePublic = useCallback(async (checked: boolean) => {
    if (!id) return;
    setIsPublic(checked);
    setSavingSwitchPublic(true);
    try {
      await api.patch(`/licensees/${id}`, {
        locator: {
          is_public: checked,
        },
      });
      if (locatorSnapshot.current) {
        locatorSnapshot.current.isPublic = checked;
      }
      showToast({
        type: "success",
        message: checked
          ? "Perfil visível no localizador!"
          : "Perfil ocultado do localizador.",
      });
    } catch {
      setIsPublic(!checked);
      showToast({
        type: "error",
        message: "Erro ao atualizar visibilidade.",
      });
    } finally {
      setSavingSwitchPublic(false);
    }
  }, [id]);

  // Toggle FixPoint
  const handleToggleFixpoint = useCallback(async (checked: boolean) => {
    if (!id) return;
    setIsFixpoint(checked);
    setSavingSwitchFixpoint(true);
    try {
      await api.patch(`/licensees/${id}`, { is_fixpoint: checked });
      showToast({
        type: "success",
        message: checked
          ? "FixPoint ativado com sucesso!"
          : "FixPoint desativado.",
      });
    } catch {
      setIsFixpoint(!checked);
      showToast({
        type: "error",
        message: "Erro ao atualizar status do FixPoint.",
      });
    } finally {
      setSavingSwitchFixpoint(false);
    }
  }, [id]);

  // Toggle Licenciado Teste (is_test)
  const handleToggleTest = useCallback(async (checked: boolean) => {
    if (!id) return;
    setIsTest(checked);
    setSavingSwitchTest(true);
    try {
      await api.patch(`/licensees/${id}`, { is_test: checked });
      showToast({
        type: "success",
        message: checked
          ? "Licenciado marcado como conta de teste!"
          : "Licenciado removido do modo de teste.",
      });
    } catch {
      setIsTest(!checked);
      showToast({
        type: "error",
        message: "Erro ao atualizar status de licenciado teste.",
      });
    } finally {
      setSavingSwitchTest(false);
    }
  }, [id]);

  // Topbar Navigation Action: Voltar, Nome do Licenciado e Tag de Status
  useEffect(() => {
    const displayName = headerDisplayName || (isFixiter ? "Fixiter" : "Licenciado");
    const statusType = isBlocked
      ? "BLOCKED"
      : isCancelled
      ? "CANCELLED"
      : customerSituation === "onboarding"
      ? "ONBOARDING"
      : "OPERATIONAL";
    const statusLabel = isBlocked
      ? "Bloqueado"
      : isCancelled
      ? "Cancelado"
      : customerSituation === "onboarding"
      ? "Onboarding"
      : "Operacional";
    const statusColor = isBlocked
      ? "#eb5757"
      : isCancelled
      ? "#6c757d"
      : customerSituation === "onboarding"
      ? "var(--development)"
      : "#27ae60";

    setNavigationAction({
      action: "function",
      functionToBeExecuted: () => {
        if (window.history.state && window.history.state.idx > 0) {
          navigate(-1);
        } else if (isSelfProfile) {
          navigate("/dashboard");
        } else {
          navigate(isFixiter ? "/customers/fixiters" : "/customers/licensees");
        }
      },
      hasButton: true,
      description: (
        <HeaderTitleWrapper>
          <HeaderTitleText title={displayName}>{displayName}</HeaderTitleText>
          <StatusPill $status={statusType}>
            <StatusBolinha color={statusColor} />
            {statusLabel}
          </StatusPill>
        </HeaderTitleWrapper>
      ) as any,
    });

    return () => {
      setNavigationAction(undefined);
    };
  }, [
    headerDisplayName,
    isFixiter,
    isSelfProfile,
    isBlocked,
    isCancelled,
    customerSituation,
    navigate,
    setNavigationAction,
  ]);

  const licenseeRef = useRef(licensee);
  licenseeRef.current = licensee;
  const userRef = useRef(user);
  userRef.current = user;
  const loadedTargetIdRef = useRef<string | null>(null);

  // Carregamento inicial de dados
  const loadData = useCallback(async () => {
    setLoading(true);

    try {
      const currentLicensee = licenseeRef.current;
      const currentUser = userRef.current;
      let targetId = id;
      let fallbackOnboardData: any = null;

      if (!targetId && isSelfProfile) {
        try {
          const onboardRes = await api.get("/licensees/user/onboard");
          fallbackOnboardData = onboardRes.data;
          if (fallbackOnboardData?.id) {
            targetId = String(fallbackOnboardData.id);
            setResolvedSelfId(targetId);
          }
        } catch {
          // Segue com fallback dos dados em memória (licensee / user)
        }
      }

      if (!targetId) {
        loadedTargetIdRef.current = "self-fallback";
        if (isSelfProfile) {
          const src: any = fallbackOnboardData || currentLicensee || currentUser || {};
          const fallbackName =
            src.name ||
            currentUser?.person?.name ||
            (currentUser as any)?.name ||
            "";
          const fallbackEmail =
            src.user?.email ||
            src.email ||
            currentUser?.email ||
            "";
          const fallbackPhone = formatPhoneInput(
            src.phone ||
              src.cellphone ||
              currentUser?.person?.cellphone ||
              (currentUser as any)?.phone ||
              ""
          );
          const fallbackDoc = cpfMask(
            src.document_number ||
              src.cpf ||
              currentUser?.person?.cpf ||
              ""
          );

          setHeaderDisplayName(getLicenseeDisplayName(src) || fallbackName);
          setCustomerName(fallbackName);
          setEmail(fallbackEmail);
          setPhone(fallbackPhone);
          setDocumentNumber(fallbackDoc);

          if (currentUser?.person || fallbackName || fallbackEmail) {
            const rawRole = (currentUser as any)?.role;
            setPersons([
              {
                id: currentUser?.person?.id || "main-person",
                name: currentUser?.person?.name || fallbackName || "Usuário Principal",
                cpf: currentUser?.person?.cpf || fallbackDoc,
                cellphone: currentUser?.person?.cellphone || fallbackPhone,
                expertise: (currentUser?.person as any)?.expertise || "",
                professional_number:
                  (currentUser?.person as any)?.professional_number ||
                  (currentUser?.person as any)?.bp_register ||
                  "",
                user: {
                  id: currentUser?.id || "",
                  role:
                    typeof rawRole === "string"
                      ? rawRole
                      : rawRole?.name || "Profissional",
                  email: fallbackEmail,
                },
              },
            ]);
          }
        }
        setLoading(false);
        return;
      }

      loadedTargetIdRef.current = String(targetId);

      // Saldo de FixCoins em background (não bloqueia a abertura da tela e não roda no próprio perfil)
      if (!isSelfProfile) {
        api
          .get(`/transactions/fixcoin/${targetId}`)
          .then((res) => {
            if (res.data !== undefined) {
              setFixcoinsBalance(
                typeof res.data === "number" ? res.data : Number(res.data) || 0
              );
            }
          })
          .catch(() => {});
      }

      const [
        customerRes,
        addressRes,
        personsRes,
        plansRes,
        signatureRes,
      ] = await Promise.allSettled([
        fallbackOnboardData
          ? Promise.resolve({ data: fallbackOnboardData })
          : api.get(`/licensees/${targetId}`).catch((err) =>
              isSelfProfile ? api.get("/licensees/user/onboard") : Promise.reject(err)
            ),
        api.get(`/address/all/${targetId}`),
        api.get(`/person/all/${targetId}`),
        api.get("/plans", {
          params: { is_active: true },
        }),
        api.get(`/signatures/${targetId}`),
      ]);

      // 1. Dados do Cliente
      let loadedCustomerName = "";
      let loadedCompanyName = "";
      let loadedPhone = "";
      let loadedEmail = "";
      let loadedInstagram = "";
      let loadedDoc = "";
      let resolvedPersonType: "FISICA" | "JURIDICA" = "FISICA";
      let loadedIsFixpoint = false;
      let loadedIsTest = false;
      let loadedIsPublic = true;
      let loadedProviderId = "";

      const rawCustomerData =
        customerRes.status === "fulfilled" && customerRes.value?.data
          ? customerRes.value.data
          : isSelfProfile
          ? fallbackOnboardData || currentLicensee || null
          : null;

      if (rawCustomerData) {
        const c = rawCustomerData;

        resolvedPersonType =
          c.person_type === "JURIDICA" || String(c.person_type || "").toLowerCase() === "juridica"
            ? "JURIDICA"
            : "FISICA";

        const rawDoc =
          c.document_number ||
          c.cnpj ||
          c.cpf ||
          c.user?.document_number ||
          (isSelfProfile ? currentUser?.person?.cpf : "") ||
          "";
        const docDigits = String(rawDoc).replace(/\D/g, "");
        loadedDoc =
          resolvedPersonType === "JURIDICA" ? cnpjMask(docDigits) : cpfMask(docDigits);

        const rawPhone =
          c.phone ||
          c.cellphone ||
          c.company_phone ||
          c.commercial_phone ||
          c.user?.phone ||
          (isSelfProfile ? currentUser?.person?.cellphone : "") ||
          "";

        loadedCustomerName =
          c.name || (isSelfProfile ? currentUser?.person?.name || (currentUser as any)?.name || "" : "");
        loadedCompanyName =
          resolvedPersonType === "JURIDICA"
            ? c.company_name ||

              c.fantasy_name ||
              ""
            : "";
        loadedPhone = formatPhoneInput(rawPhone);
        loadedEmail =
          c.email ||
          c.user?.email ||
          c.person?.user?.email ||
          (isSelfProfile ? currentUser?.email || "" : "");
        loadedInstagram = c.instagram || "";
        loadedIsFixpoint = Boolean(c.is_fixpoint);
        loadedIsTest = Boolean(c.is_test);
        loadedIsPublic = c.locator?.is_public ?? c.locator_is_public ?? c.is_public ?? true;
        loadedProviderId = c.provider_id || c.provider?.id || "";

        const resolvedDisplayName =
          resolvedPersonType === "JURIDICA"
            ? loadedCompanyName || loadedCustomerName
            : loadedCustomerName;

        setHeaderDisplayName(resolvedDisplayName);
        setCustomerName(loadedCustomerName);
        setCompanyName(loadedCompanyName);
        setPersonType(resolvedPersonType);
        setDocumentNumber(loadedDoc);
        setEmail(loadedEmail);
        setPhone(loadedPhone);
        setInstagram(loadedInstagram);
        setIsFixpoint(loadedIsFixpoint);
        setIsTest(loadedIsTest);
        setIsPublic(loadedIsPublic);
        setIsBlocked(Boolean(c.is_blocked));
        setIsCancelled(Boolean(c.cancelled_at || c.churned_at));
        setCustomerSituation(c.situation || (c.is_active ? "operational" : "onboarding"));
        setProviderId(loadedProviderId);
        providerSnapshot.current = loadedProviderId;

        // Locator Fields
        const locName = c.locator?.name || c.locator_name || c.display_name || "";
        const locPh = formatPhoneInput(c.locator?.phone || c.locator_phone || c.public_phone || "");

        const defaultContactName = resolvedDisplayName;

        const locUseBilling = c.locator?.use_billing_contact ?? c.locator_use_billing_contact;
        const sameContact =
          locUseBilling !== undefined
            ? Boolean(locUseBilling)
            : (!locName || (locName === defaultContactName && (!locPh || locPh === loadedPhone)));

        setUseSameContact(sameContact);
        setLocatorName(locName || defaultContactName);
        setLocatorPhone(locPh || loadedPhone);

        const locPic = c.locator?.picture_link || c.locator_picture_link || c.picture_link || null;
        setLocatorPictureLink(locPic);

        locatorSnapshot.current = {
          isPublic: loadedIsPublic,
          useSameContact: sameContact,
          locatorName: locName || defaultContactName,
          locatorPhone: locPh || loadedPhone,
          pictureLink: locPic,
          useSameAddress: true,
          locCep: "",
          locStreet: "",
          locNumber: "",
          locNoNumber: false,
          locComplement: "",
          locNoComplement: false,
          locDistrict: "",
          locCity: "",
          locState: "",
        };

        if (Array.isArray(c.printers)) {
          const loadedPrinters: IOption[] = c.printers
            .filter((p: any) => p && p.id != null)
            .map((p: any) => ({
              value: p.id,
              optionText: p.name || "",
            }));
          setSelectedPrinters(loadedPrinters);
          printersSnapshot.current = loadedPrinters;
        }

        const rawCourseObj =
          c.course ||
          c.course_licensee?.course ||
          c.courseLicensee?.course ||
          (Array.isArray(c.courses) && c.courses.length > 0 ? c.courses[0] : null) ||
          (Array.isArray(c.course_licensees) && c.course_licensees.length > 0
            ? c.course_licensees[0]?.course || c.course_licensees[0]
            : null) ||
          (Array.isArray(c.courseLicensees) && c.courseLicensees.length > 0
            ? c.courseLicensees[0]?.course || c.courseLicensees[0]
            : null);
        const rawCourseId =
          c.course_id ||
          c.courseId ||
          c.course_licensee?.course_id ||
          c.courseLicensee?.course_id ||
          rawCourseObj?.course_id ||
          rawCourseObj?.id ||
          "";
        const rawCourseName =
          rawCourseObj?.name || rawCourseObj?.course_name || c.course_name || "";
        const rawCourseDate =
          rawCourseObj?.date || rawCourseObj?.course_date || c.course_date || "";
        const rawCourseDuration =
          rawCourseObj?.duration_hours !== undefined
            ? rawCourseObj.duration_hours
            : c.duration_hours;
        if (rawCourseId) setLinkedCourseId(String(rawCourseId));
        if (rawCourseName) setLinkedCourseName(String(rawCourseName));
        if (rawCourseDate) setLinkedCourseDate(String(rawCourseDate));
        if (rawCourseDuration !== undefined) {
          setLinkedCourseDuration(rawCourseDuration);
        }
        if (rawCourseId || rawCourseName) {
          persistLinkedCourse(
            {
              id: rawCourseId ? String(rawCourseId) : undefined,
              name: rawCourseName ? String(rawCourseName) : undefined,
              date: rawCourseDate ? String(rawCourseDate) : undefined,
              duration_hours: rawCourseDuration,
            },
            targetId ? String(targetId) : undefined
          );
        }
      }

      // 2. Dados dos Usuários (Person)
      let loadedPersons: IPerson[] = [];
      if (
        personsRes.status === "fulfilled" &&
        Array.isArray(personsRes.value.data) &&
        personsRes.value.data.length > 0
      ) {
        loadedPersons = personsRes.value.data.filter(
          (p: any) => p && typeof p === "object"
        );
      }
      if (loadedPersons.length === 0 && rawCustomerData) {
        const c = rawCustomerData;
        if (c.person && typeof c.person === "object") {
          loadedPersons = [c.person];
        } else if (c.name || c.manager_name || c.expertise) {
          loadedPersons = [
            {
              id: "main-person",
              name: c.manager_name || c.name || "Usuário Principal",
              cpf: c.cpf || c.document_number || "",
              cellphone: c.cellphone || c.phone || "",
              expertise: c.expertise || c.professional_expertise || "",
              professional_number: c.professional_number || c.council_number || "",
              user: {
                id: c.user?.id || "",
                role: "Profissional",
                email: c.user?.email || c.email || "",
              },
            },
          ];
        }
      }
      if (loadedPersons.length === 0 && isSelfProfile && currentUser) {
        const rawRole = (currentUser as any)?.role;
        loadedPersons = [
          {
            id: currentUser.person?.id || "main-person",
            name: currentUser.person?.name || (currentUser as any).name || loadedCustomerName || "Usuário Principal",
            cpf: currentUser.person?.cpf || loadedDoc || "",
            cellphone: currentUser.person?.cellphone || loadedPhone || "",
            expertise: (currentUser.person as any)?.expertise || "",
            professional_number:
              (currentUser.person as any)?.professional_number || (currentUser.person as any)?.bp_register || "",
            user: {
              id: currentUser.id || "",
              role:
                typeof rawRole === "string"
                  ? rawRole
                  : rawRole?.name || "Profissional",
              email: currentUser.email || loadedEmail || "",
            },
          },
        ];
      }
      setPersons(loadedPersons);

      // 3. Endereço Principal (Cadastral) e Endereço do Localizador
      let loadedRegCep = "";
      let loadedRegStreet = "";
      let loadedRegNumber = "";
      let loadedRegNoNumber = false;
      let loadedRegComplement = "";
      let loadedRegNoComplement = false;
      let loadedRegDistrict = "";
      let loadedRegCity = "";
      let loadedRegState = "";

      if (addressRes.status === "fulfilled" && Array.isArray(addressRes.value.data)) {
        const addrList = addressRes.value.data.filter(
          (a: any) => a && typeof a === "object"
        );
        const mainAddr =
          addrList.find((a: any) => a.billing_address) ||
          addrList[0] ||
          null;

        if (mainAddr) {
          const isNoNum =
            mainAddr.number === "S/N" ||
            mainAddr.number === 0 ||
            mainAddr.number === "0" ||
            !mainAddr.number;
          const isNoComp =
            mainAddr.complement === "Sem complemento" ||
            mainAddr.complement === "Não possui" ||
            !mainAddr.complement;

          loadedRegCep = formatCep(mainAddr.cep || "");
          loadedRegStreet = mainAddr.address || "";
          loadedRegNumber = isNoNum ? "" : String(mainAddr.number || "");
          loadedRegNoNumber = isNoNum;
          loadedRegComplement = isNoComp ? "" : mainAddr.complement || "";
          loadedRegNoComplement = isNoComp;
          loadedRegDistrict = mainAddr.district || "";
          loadedRegCity = mainAddr.city || "";
          loadedRegState = mainAddr.state ? String(mainAddr.state).toUpperCase() : "";

          setRegAddressId(mainAddr.id);
          setRegCep(loadedRegCep);
          setRegStreet(loadedRegStreet);
          setRegNumber(loadedRegNumber);
          setRegNoNumber(loadedRegNoNumber);
          setRegComplement(loadedRegComplement);
          setRegNoComplement(loadedRegNoComplement);
          setRegDistrict(loadedRegDistrict);
          setRegCity(loadedRegCity);
          setRegState(loadedRegState);
        }

        const secondAddr =
          addrList.find(
            (a: any) => a.id !== mainAddr?.id && Boolean(a.company_address)
          ) || null;

        if (secondAddr) {
          setUseSameAddress(false);
          const isSecondNoNum =
            secondAddr.number === "S/N" ||
            secondAddr.number === 0 ||
            secondAddr.number === "0" ||
            !secondAddr.number;
          const isSecondNoComp =
            secondAddr.complement === "Sem complemento" ||
            secondAddr.complement === "Não possui" ||
            !secondAddr.complement;

          const loadedLocCep = formatCep(secondAddr.cep || "");
          const loadedLocStreet = secondAddr.address || "";
          const loadedLocNumber = isSecondNoNum ? "" : String(secondAddr.number || "");
          const loadedLocComplement = isSecondNoComp ? "" : secondAddr.complement || "";
          const loadedLocDistrict = secondAddr.district || "";
          const loadedLocCity = secondAddr.city || "";
          const loadedLocState = secondAddr.state ? String(secondAddr.state).toUpperCase() : "";

          setLocAddressId(secondAddr.id);
          setLocCep(loadedLocCep);
          setLocStreet(loadedLocStreet);
          setLocNumber(loadedLocNumber);
          setLocNoNumber(isSecondNoNum);
          setLocComplement(loadedLocComplement);
          setLocNoComplement(isSecondNoComp);
          setLocDistrict(loadedLocDistrict);
          setLocCity(loadedLocCity);
          setLocState(loadedLocState);

          if (locatorSnapshot.current) {
            locatorSnapshot.current.useSameAddress = false;
            locatorSnapshot.current.locCep = loadedLocCep;
            locatorSnapshot.current.locStreet = loadedLocStreet;
            locatorSnapshot.current.locNumber = loadedLocNumber;
            locatorSnapshot.current.locNoNumber = isSecondNoNum;
            locatorSnapshot.current.locComplement = loadedLocComplement;
            locatorSnapshot.current.locNoComplement = isSecondNoComp;
            locatorSnapshot.current.locDistrict = loadedLocDistrict;
            locatorSnapshot.current.locCity = loadedLocCity;
            locatorSnapshot.current.locState = loadedLocState;
          }
        } else {
          setUseSameAddress(true);
          setLocAddressId(null);
          setLocCep("");
          setLocStreet("");
          setLocNumber("");
          setLocNoNumber(false);
          setLocComplement("");
          setLocNoComplement(false);
          setLocDistrict("");
          setLocCity("");
          setLocState("");
        }
      }

      // Snapshot Dados de Faturamento com Endereço
      registrationSnapshot.current = {
        name: loadedCustomerName,
        companyName: loadedCompanyName,
        personType: resolvedPersonType,
        documentNumber: loadedDoc,
        email: loadedEmail,
        phone: loadedPhone,
        instagram: loadedInstagram,
        regCep: loadedRegCep,
        regStreet: loadedRegStreet,
        regNumber: loadedRegNumber,
        regNoNumber: loadedRegNoNumber,
        regComplement: loadedRegComplement,
        regNoComplement: loadedRegNoComplement,
        regDistrict: loadedRegDistrict,
        regCity: loadedRegCity,
        regState: loadedRegState,
      };

      // 4. Planos e Assinatura
      let loadedPlans: IPlans[] = [];
      if (plansRes.status === "fulfilled" && Array.isArray(plansRes.value.data)) {
        loadedPlans = plansRes.value.data.filter((p: any) => p && p.id != null);
        setActivePlans(loadedPlans);
      }

      let activeSig: ISignature | null = null;
      let rawSignatures: ISignature[] = [];

      const isCurrentSig = (s: any) =>
        Boolean(s) &&
        (!s.end_date || new Date(s.end_date).getTime() >= Date.now()) &&
        s.status !== "cancelled" &&
        s.status !== "canceled";

      const sortSignaturesDesc = (list: any[]) =>
        [...list].sort((a, b) => {
          const tA = new Date(a?.created_at || a?.start_date || 0).getTime();
          const tB = new Date(b?.created_at || b?.start_date || 0).getTime();
          return (isNaN(tB) ? 0 : tB) - (isNaN(tA) ? 0 : tA);
        });

      if (signatureRes.status === "fulfilled" && signatureRes.value.data) {
        if (Array.isArray(signatureRes.value.data)) {
          rawSignatures = sortSignaturesDesc(
            signatureRes.value.data.filter(
              (s: any) => s && typeof s === "object"
            )
          );
          activeSig = rawSignatures.find(isCurrentSig) || null;
        } else if (typeof signatureRes.value.data === "object") {
          const s = signatureRes.value.data;
          rawSignatures = [s];
          activeSig = isCurrentSig(s) ? s : null;
        }
      }

      if (rawCustomerData) {
        const c = rawCustomerData;
        if (Array.isArray(c.signature) && c.signature.length > 0) {
          const validCustSigs = sortSignaturesDesc(
            c.signature.filter(
              (s: any) => s && typeof s === "object"
            )
          );
          if (rawSignatures.length === 0) {
            rawSignatures = validCustSigs;
          }
          if (!activeSig) {
            activeSig = validCustSigs.find(isCurrentSig) || null;
          }
        }
        if (!activeSig && c.active_signature && isCurrentSig(c.active_signature)) {
          activeSig = c.active_signature;
          if (rawSignatures.length === 0) {
            rawSignatures = [c.active_signature];
          }
        }
      }

      // Normalizar e enriquecer assinaturas com objeto de plano e datas
      const normalizeSignature = (sig: any): ISignature => {
        if (!sig) return sig;
        const planObj = sig.plan || sig.plans;
        const targetPlanId = planObj?.id || sig.plan_id;
        const matched = targetPlanId
          ? loadedPlans.find((p) => String(p.id) === String(targetPlanId))
          : undefined;
        const finalPlan = matched
          ? { ...(planObj || {}), ...matched }
          : planObj;
        return {
          ...sig,
          plan: finalPlan,
          created_at: sig.created_at || sig.start_date,
        };
      };

      rawSignatures = sortSignaturesDesc(
        rawSignatures.filter(Boolean).map(normalizeSignature)
      );
      if (activeSig) {
        activeSig = normalizeSignature(activeSig);
        if (
          activeSig.plan?.id &&
          !loadedPlans.some((p) => String(p.id) === String(activeSig?.plan?.id))
        ) {
          loadedPlans = [activeSig.plan, ...loadedPlans];
          setActivePlans(loadedPlans);
        }
      }

      setCurrentSignature(activeSig);
      setAllSignatures(rawSignatures);

      if (activeSig) {
        // 1. is_blocked false e vigente -> Ativa
        // 2. is_blocked true e vigente -> Bloqueada (ainda possui assinatura, apenas travada)
        const isSigBlocked = Boolean(
          (activeSig as any).is_blocked === true ||
          (activeSig as any).status === "blocked"
        );
        const isCustBlocked = Boolean(
          rawCustomerData &&
            (rawCustomerData.is_blocked === true ||
              rawCustomerData.signature_status === "blocked" ||
              rawCustomerData.situation === "blocked")
        );
        setIsCancelled(false);
        setIsBlocked(isSigBlocked || isCustBlocked);
      } else {
        // 3. Sem assinatura vigente (todas canceladas ou com end_date < NOW()) -> Cancelado
        const hasCancelledSig = rawSignatures.some(
          (s: any) =>
            s &&
            (s.status === "cancelled" ||
              s.status === "canceled" ||
              (Boolean(s.end_date) && new Date(s.end_date).getTime() < Date.now()))
        );
        const isClientCancelled = Boolean(
          rawCustomerData &&
            (rawCustomerData.cancelled_at ||
              rawCustomerData.churned_at ||
              rawCustomerData.situation === "cancelled" ||
              rawCustomerData.signature_status === "cancelled")
        );
        setIsCancelled(hasCancelledSig || isClientCancelled);
        setIsBlocked(false);
      }

      if (activeSig?.plan?.plan_name && targetId) {
        setCustomerPlanCache(targetId, activeSig.plan.plan_name);
      }

      let loadedPlanId = "";
      let loadedStartDate = "";
      let loadedEndDate = "";
      let loadedNoExpiration = false;

      if (activeSig) {
        loadedPlanId = String(activeSig.plan?.id || (activeSig as any).plan_id || "");
        loadedStartDate = safeDateToInput(activeSig.created_at);
        if (activeSig.end_date) {
          loadedEndDate = safeDateToInput(activeSig.end_date);
          loadedNoExpiration = false;
        } else {
          loadedEndDate = "";
          loadedNoExpiration = true;
        }
      } else {
        loadedPlanId = "";
        loadedStartDate = safeDateToInput(new Date());
        loadedEndDate = "";
        loadedNoExpiration = true;
      }

      setSelectedPlanId(loadedPlanId);
      setSignatureStartDate(loadedStartDate);
      setSignatureEndDate(loadedEndDate);
      setNoExpiration(loadedNoExpiration);

      signatureSnapshot.current = {
        planId: loadedPlanId,
        startDate: loadedStartDate,
        endDate: loadedEndDate,
        noExpiration: loadedNoExpiration,
      };

      // --- ADESÃO & EQUIPAMENTOS ---
      let normVolt: "110v" | "220v" | "" = "";
      let wantsHG = true;
      let hasInitialKit = false;

      if (rawCustomerData) {
        const c = rawCustomerData;
        const meta = c.metadata || {};
        let localMeta: Record<string, any> = {};
        try {
          const cached = localStorage.getItem(`customer_equipment_${targetId}`);
          if (cached) localMeta = JSON.parse(cached);
        } catch (_) {}
        const mergedMeta = { ...meta, ...localMeta };
        setCustomerMetadata(mergedMeta);

        const rawVolt = String(
          mergedMeta.heat_gun_voltage || mergedMeta.voltage || mergedMeta.equipment_voltage || ""
        );
        normVolt = rawVolt.includes("220") ? "220v" : rawVolt.includes("110") ? "110v" : "";
        wantsHG = mergedMeta.wants_heat_gun !== false;
        hasInitialKit = Boolean(c.ordered_initial_kit);

        setEquipmentVoltage(normVolt);
        setWantsHeatGun(wantsHG);
        setOrderedInitialKit(hasInitialKit);
      }

      onboardingSnapshot.current = {
        voltage: normVolt,
        wantsHeatGun: wantsHG,
      };
    } catch {
      showToast({
        type: "error",
        message: "Erro ao carregar as informações.",
      });
    } finally {
      setLoading(false);
    }
  }, [id, isSelfProfile]);

  useEffect(() => {
    if (id && loadedTargetIdRef.current === String(id)) {
      return;
    }
    printersLoadedRef.current = false;
    providersLoadedRef.current = false;
    loadData();
  }, [id, isSelfProfile, loadData]);

  // Recarregar Usuários do Licenciado
  const getLicenseePersons = useCallback(async () => {
    if (!id) return;
    try {
      const res = await api.get(`/person/all/${id}`);
      if (Array.isArray(res.data)) {
        setPersons(res.data.filter((p: any) => p && typeof p === "object"));
      }
    } catch {
      // fallback silencioso
    }
  }, [id]);

  // --- BLOCK ASSINATURA HANDLERS ---
  const handleToggleEditSignature = () => {
    if (!isEditingSignature) {
      signatureSnapshot.current = {
        planId: selectedPlanId,
        startDate: signatureStartDate,
        endDate: signatureEndDate,
        noExpiration,
      };
      setIsEditingSignature(true);
      setIsAddingSignature(false);
    }
  };

  const handleStartAddSignature = () => {
    signatureSnapshot.current = {
      planId: selectedPlanId,
      startDate: signatureStartDate,
      endDate: signatureEndDate,
      noExpiration,
    };
    const defaultPlan = activePlans[0]?.id ? String(activePlans[0].id) : "";
    setSelectedPlanId(defaultPlan);
    setSignatureStartDate(new Date().toISOString().slice(0, 10));
    setSignatureEndDate("");
    setNoExpiration(true);
    setIsAddingSignature(true);
    setIsEditingSignature(false);
  };

  const handleCancelSignature = () => {
    if (signatureSnapshot.current) {
      setSelectedPlanId(signatureSnapshot.current.planId);
      setSignatureStartDate(signatureSnapshot.current.startDate);
      setSignatureEndDate(signatureSnapshot.current.endDate);
      setNoExpiration(signatureSnapshot.current.noExpiration);
    } else {
      setSelectedPlanId("");
      setSignatureStartDate("");
      setSignatureEndDate("");
      setNoExpiration(false);
    }
    setIsEditingSignature(false);
    setIsAddingSignature(false);
  };

  // Buscar detalhes do plano selecionado (como era antes no SignatureInfoModal)
  useEffect(() => {
    async function fetchPlanDetails() {
      if (selectedPlanId) {
        try {
          const response = await api.get(`/plans/${selectedPlanId}`);
          setPlanDetails(response.data);
        } catch {
          const fallback = activePlans.find((p) => String(p.id) === String(selectedPlanId));
          setPlanDetails(fallback || null);
        }
      } else {
        setPlanDetails(null);
      }
    }
    fetchPlanDetails();
  }, [selectedPlanId, activePlans]);

  const handleSaveSignature = async () => {
    if (!selectedPlanId) {
      showToast({ type: "error", message: "Selecione um plano para a assinatura." });
      return;
    }

    if (!noExpiration && !signatureEndDate) {
      showToast({
        type: "error",
        message: "Informe a data de encerramento ou marque 'Sem validade (plano contínuo)'.",
      });
      return;
    }

    setSavingSignature(true);
    try {
      const formattedStartDate = safeDateToISO(signatureStartDate, false);
      const formattedEndDate =
        noExpiration || !signatureEndDate
          ? null
          : safeDateToISO(signatureEndDate, true) || null;

      if (isAddingSignature) {
        // Se já havia uma assinatura ativa, encerra a anterior no backend
        if (currentSignature) {
          try {
            await api.patch(`/licensees/cancellation/${id}`, {});
          } catch (cancellationErr) {
            console.warn("Aviso ao encerrar assinatura anterior:", cancellationErr);
          }
        }

        // Cadastra nova assinatura ativa (POST /signatures)
        const assignPlanBody = {
          licensee_id: id,
          plan_id: selectedPlanId,
          created_at: formattedStartDate,
          end_date: formattedEndDate,
        };
        await api.post("/signatures", assignPlanBody);
        showToast({ type: "success", message: "Assinatura adicionada com sucesso!" });
        setIsAddingSignature(false);
        setIsCancelled(false);
        setIsBlocked(false);
      } else if (currentSignature && currentSignature.id) {
        // Alteração de plano e datas da assinatura do cliente
        const changePlanBody = {
          id: currentSignature.id,
          licensee_id: id,
          plan_id: selectedPlanId,
          created_at: formattedStartDate,
          end_date: formattedEndDate,
        };

        await api.patch("/signatures/change-plan", changePlanBody);
        showToast({ type: "success", message: "Assinatura salva com sucesso!" });
        setIsEditingSignature(false);
      }

      const savedPlanName =
        activePlans.find((p) => String(p.id) === String(selectedPlanId))?.plan_name ||
        planDetails?.plan_name ||
        "";
      if (savedPlanName && id) {
        setCustomerPlanCache(id, savedPlanName);
      }

      loadData();
    } catch (err: any) {
      console.error(err);
      const backendMessage = err?.response?.data?.message;
      showToast({
        type: "error",
        message: backendMessage || "Erro ao salvar assinatura.",
      });
    } finally {
      setSavingSignature(false);
    }
  };

  // Action: Abrir modal de Cancelar Assinatura / Contrato (Churn)
  const handleCancelCustomer = () => {
    setCancelConfirmationText("");
    setIsCancelModalOpen(true);
  };

  const handleConfirmCancelSubscription = async () => {
    if (!id) return;
    if (cancelConfirmationText.trim().toLowerCase() !== "cancelar") return;

    setIsCancellingSubscription(true);
    const name = headerDisplayName || customerName || companyName || "cliente";
    try {
      await api.put("/signatures/deactivate-plan", { licensee_id: id });
      setIsCancelled(true);
      showToast({
        type: "success",
        message: `Assinatura de ${name} cancelada com sucesso.`,
      });
      setIsCancelModalOpen(false);
      setCancelConfirmationText("");
      loadData();
    } catch {
      showToast({
        type: "error",
        message: `Erro ao cancelar assinatura de ${name}.`,
      });
    } finally {
      setIsCancellingSubscription(false);
    }
  };


  const handleConfirmDeleteSignature = async () => {
    if (!signatureToDelete) return;
    if (deleteConfirmationText.trim().toLowerCase() !== "excluir") return;

    setIsDeletingSignature(true);
    try {
      try {
        await api.delete(`/signatures/${signatureToDelete.id}`);
        showToast({
          type: "success",
          message: "Registro de assinatura excluído com sucesso.",
        });
      } catch (err: any) {
        if (err?.response?.status === 404 || err?.response?.status === 501) {
          showToast({
            type: "warning",
            message:
              "Rota DELETE /signatures/:id pendente no backend. Registro removido localmente.",
          });
        } else {
          throw err;
        }
      }

      const deletedId = signatureToDelete.id;
      setAllSignatures((prev) => prev.filter((s) => s.id !== deletedId));
      if (currentSignature?.id === deletedId) {
        setCurrentSignature(null);
      }
      setSignatureToDelete(null);
      setDeleteConfirmationText("");
      loadData();
    } catch (err: any) {
      console.error(err);
      showToast({
        type: "error",
        message: err?.response?.data?.message || "Erro ao excluir assinatura.",
      });
    } finally {
      setIsDeletingSignature(false);
    }
  };

  const signatureHistoryColumns = useMemo<Column<ISignature>[]>(
    () => [
      {
        key: "plan",
        header: "Plano",
        render: (row) => (
          <UserName>
            {row.plan?.plan_name || (row as any).plans?.plan_name || "Plano Fixit"}
          </UserName>
        ),
      },
      {
        key: "start_date",
        header: "Data de Início",
        render: (row) => {
          const dateVal = row.created_at || (row as any).start_date;
          return (
            <UserEmailCell>
              {safeFormatDatePtBr(dateVal, "-")}
            </UserEmailCell>
          );
        },
      },
      {
        key: "end_date",
        header: "Data de Encerramento",
        render: (row) => (
          <UserEmailCell>
            {row.end_date ? safeFormatDatePtBr(row.end_date, "Sem validade") : "Sem validade"}
          </UserEmailCell>
        ),
      },
      {
        key: "status",
        header: "Status",
        render: (row) => {
          const sigStatus = (row as any).status;
          const isExplicitlyCancelled =
            sigStatus === "cancelled" || sigStatus === "canceled";
          const isExpired =
            !isExplicitlyCancelled &&
            Boolean(row.end_date) &&
            new Date(row.end_date).getTime() < Date.now();
          const isBlocked =
            !isExplicitlyCancelled &&
            !isExpired &&
            (sigStatus === "blocked" || Boolean((row as any).is_blocked));
          const hasFutureEndDate =
            Boolean(row.end_date) &&
            new Date(row.end_date).getTime() >= Date.now();

          if (isExplicitlyCancelled) {
            return (
              <HistoryStatusBadge status="canceled">
                Cancelada
              </HistoryStatusBadge>
            );
          }

          if (isExpired) {
            return (
              <HistoryStatusBadge status="canceled">
                Expirada
              </HistoryStatusBadge>
            );
          }

          if (isBlocked) {
            return (
              <HistoryStatusBadge status="blocked">
                Bloqueada
              </HistoryStatusBadge>
            );
          }

          if (hasFutureEndDate) {
            return (
              <HistoryStatusBadge status="active">
                Ativa (Válida até {safeFormatDatePtBr(row.end_date, "—")})
              </HistoryStatusBadge>
            );
          }

          return (
            <HistoryStatusBadge status="active">
              Ativa
            </HistoryStatusBadge>
          );
        },
      },
      ...(!isSelfProfile
        ? [
            {
              key: "actions",
              header: "Ações",
              render: (row: ISignature) => (
                <ActionIconButton
                  type="button"
                  color="var(--error)"
                  title="Excluir permanentemente do banco"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSignatureToDelete(row);
                    setDeleteConfirmationText("");
                  }}
                >
                  <FiTrash2 size={16} />
                </ActionIconButton>
              ),
            },
          ]
        : []),
    ],
    [currentSignature, isSelfProfile]
  );

  const planColumns = useMemo<Column<any>[]>(
    () => [
      {
        key: "currency",
        header: "Moeda",
        render: (row) => {
          const currencyCode = typeof row.currency === "string" ? row.currency : (row.currency?.value || "BRL");
          return currencyCode === "USD" ? "Dólar (USD)" : "Real (BRL)";
        },
      },
      {
        key: "monthly",
        header: "Mensalidade",
        render: (row) => {
          const priceNum = Number(row.price);
          if (!row.price || priceNum === 0 || row.is_free) {
            return "Isento";
          }
          const currencyCode = typeof row.currency === "string" ? row.currency : (row.currency?.value || "BRL");
          const symbol = currencyCode === "USD" ? "$" : "R$";
          return `${symbol} ${priceNum.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;
        },
      },
      {
        key: "price_table",
        header: "Tabela de Preços",
        render: (row) => row.price_table?.name || "Não definida",
      },
      {
        key: "custom_tax",
        header: "Taxa de Personalização",
        render: (row) => {
          if (row.custom_tax === null || row.custom_tax === undefined || row.custom_tax === "") {
            return "Não definida";
          }
          const customTaxNum = Number(row.custom_tax);
          if (isNaN(customTaxNum)) return "Não definida";
          const currencyCode = typeof row.currency === "string" ? row.currency : (row.currency?.value || "BRL");
          const symbol = currencyCode === "USD" ? "$" : "R$";
          return `${symbol} ${customTaxNum.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;
        },
      },
      {
        key: "urgency_tax",
        header: "Taxa de Urgência",
        render: (row) => {
          if (row.urgency_tax === null || row.urgency_tax === undefined || row.urgency_tax === "") {
            return "Não definida";
          }
          const urgencyTaxNum = Number(row.urgency_tax);
          if (isNaN(urgencyTaxNum)) return "Não definida";
          const currencyCode = typeof row.currency === "string" ? row.currency : (row.currency?.value || "BRL");
          const symbol = currencyCode === "USD" ? "$" : "R$";
          return `${symbol} ${urgencyTaxNum.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;
        },
      },
    ],
    []
  );

  // --- BLOCK 2 HANDLERS (USUÁRIOS / PERSON) ---
  const handleOpenNewUserModal = () => {
    setEditingPerson(null);
    setModalPersonName("");
    setModalPersonCellphone("");
    setModalPersonEmail("");
    setModalPersonExpertise("");
    setModalPersonCouncilNumber("");
    setIsUserModalOpen(true);
  };

  const handleOpenEditUserModal = useCallback((p: IPerson) => {
    setEditingPerson(p);
    setModalPersonName(p.name || "");
    setModalPersonCellphone(formatPhoneInput(p.cellphone || ""));
    setModalPersonEmail(p.user?.email || "");
    setModalPersonExpertise(p.expertise || "");
    setModalPersonCouncilNumber(p.professional_number || p.bp_register || "");
    setIsUserModalOpen(true);
  }, []);

  const handleSavePersonModal = async () => {
    if (!modalPersonName.trim()) {
      showToast({ type: "error", message: "Informe o nome do usuário." });
      return;
    }

    setSavingPerson(true);
    try {
      const rawPhone = modalPersonCellphone.replace(/\D/g, "");

      const body: Record<string, any> = {
        licensee: { id },
        licensee_id: id,
        name: modalPersonName.trim(),
        cellphone: rawPhone,
        expertise: modalPersonExpertise,
        professional_number: modalPersonCouncilNumber.trim(),
        bp_register: modalPersonCouncilNumber.trim(),
      };

      if (
        editingPerson &&
        editingPerson.id &&
        String(editingPerson.id) !== "main-person" &&
        !String(editingPerson.id).startsWith("local-")
      ) {
        await api.put(`/person/update/${editingPerson.id}`, body);
        showToast({ type: "success", message: "Usuário atualizado com sucesso!" });
      } else {
        await api.post("/person", body);
        showToast({ type: "success", message: "Usuário cadastrado com sucesso!" });
      }

      setIsUserModalOpen(false);
      await getLicenseePersons();
    } catch {
      if (editingPerson) {
        setPersons((prev) =>
          prev.map((p) =>
            p.id === editingPerson.id
              ? {
                  ...p,
                  name: modalPersonName.trim(),
                  cellphone: modalPersonCellphone,
                  expertise: modalPersonExpertise,
                  professional_number: modalPersonCouncilNumber.trim(),
                  user: {
                    ...p.user,
                    email: modalPersonEmail || p.user?.email,
                  },
                }
              : p
          )
        );
        showToast({ type: "success", message: "Dados do usuário atualizados na interface!" });
      } else {
        const newPerson: IPerson = {
          id: `local-${Date.now()}`,
          name: modalPersonName.trim(),
          cellphone: modalPersonCellphone,
          expertise: modalPersonExpertise,
          professional_number: modalPersonCouncilNumber.trim(),
          user: {
            email: modalPersonEmail,
          },
        };
        setPersons((prev) => [...prev, newPerson]);
        showToast({ type: "success", message: "Usuário adicionado com sucesso!" });
      }
      setIsUserModalOpen(false);
    } finally {
      setSavingPerson(false);
    }
  };

  const handleDeletePerson = useCallback(async (personId: string) => {
    if (!window.confirm("Tem certeza que deseja remover este usuário?")) return;
    try {
      const pidStr = String(personId || "");
      if (pidStr && pidStr !== "main-person" && !pidStr.startsWith("local-")) {
        await api.delete(`/person/${personId}`);
      }
    } catch {
      // fallback silencioso para remoção na interface
    }
    setPersons((prev) => prev.filter((p) => p.id !== personId));
    showToast({ type: "success", message: "Usuário removido com sucesso!" });
  }, []);

  const isLoggedUserRow = useCallback(
    (row?: IPerson | null): boolean => {
      if (!row || !user) return false;
      if (row.user?.id && user.id && String(row.user.id) === String(user.id)) {
        return true;
      }
      if (row.id && user.person?.id && String(row.id) === String(user.person.id)) {
        return true;
      }
      if (
        row.user?.email &&
        user.email &&
        row.user.email.trim().toLowerCase() === user.email.trim().toLowerCase()
      ) {
        return true;
      }
      if (isSelfProfile && row.id === "main-person") {
        return true;
      }
      return false;
    },
    [user, isSelfProfile]
  );

  const sortedPersons = useMemo(() => {
    return [...persons].sort((a, b) => {
      const aSelf = isLoggedUserRow(a) ? 0 : 1;
      const bSelf = isLoggedUserRow(b) ? 0 : 1;
      return aSelf - bSelf;
    });
  }, [persons, isLoggedUserRow]);

  const handleOpenChangePassword = useCallback(
    (row: IPerson) => {
      const targetUserId = row.user?.id || user?.id || "";
      if (!targetUserId) {
        showToast({
          type: "error",
          message: "Não foi possível identificar o usuário para alteração de senha.",
        });
        return;
      }
      setChangePasswordUserId(String(targetUserId));
      setIsChangePasswordOpen(true);
    },
    [user?.id]
  );

  const handleSendPasswordReset = useCallback(async (row: IPerson) => {
    const targetEmail = row.user?.email?.trim();
    if (!targetEmail) {
      showToast({
        type: "error",
        message: "Este usuário não possui um e-mail cadastrado para envio da redefinição.",
      });
      return;
    }

    setSendingResetPersonId(row.id);
    try {
      await api.post("/users/validate", { email: targetEmail });
      showToast({
        type: "success",
        message: `Redefinição de senha enviada para ${targetEmail}!`,
      });
    } catch (error: any) {
      showToast({
        type: "error",
        message:
          error?.response?.data?.message ||
          "Não foi possível enviar a redefinição de senha para este e-mail.",
      });
    } finally {
      setSendingResetPersonId(null);
    }
  }, []);

  const userColumns: Column<IPerson>[] = useMemo(
    () => [
      {
        key: "identification",
        header: "Usuário",
        width: "42%",
        render: (row) => {
          const safeName = String(row?.name || "U").trim() || "U";
          const initials =
            safeName
              .split(/\s+/)
              .slice(0, 2)
              .map((n) => n[0] || "")
              .join("")
              .toUpperCase() || "U";
          const isSelf = isLoggedUserRow(row);
          return (
            <UserTableCell>
              <UserAvatar>{initials}</UserAvatar>
              <UserName title={row?.name || "Usuário"}>{row?.name || "Usuário"}</UserName>
              {isSelf && <UserAccountBadge>Você</UserAccountBadge>}
            </UserTableCell>
          );
        },
      },
      {
        key: "email",
        header: "E-mail",
        width: "36%",
        render: (row) => (
          <UserEmailCell title={row.user?.email || "Não informado"}>
            {row.user?.email || "Não informado"}
          </UserEmailCell>
        ),
      },
      {
        key: "password_action",
        header: "Senha",
        width: "22%",
        render: (row) => {
          const isSelf = isLoggedUserRow(row);
          const isSending = sendingResetPersonId === row.id;
          return (
            <UserPasswordActionBtn
              type="button"
              $isLoggedUser={isSelf}
              disabled={!isSelf && (!row.user?.email || isSending)}
              onClick={(e) => {
                e.stopPropagation();
                if (isSelf) {
                  handleOpenChangePassword(row);
                } else {
                  handleSendPasswordReset(row);
                }
              }}
            >
              {isSelf ? (
                <>
                  <RiKey2Line size={15} />
                  Alterar senha
                </>
              ) : (
                <>
                  <RiMailSendLine size={15} />
                  {isSending ? "Enviando..." : "Enviar redefinição"}
                </>
              )}
            </UserPasswordActionBtn>
          );
        },
      },
    ],
    [
      isLoggedUserRow,
      sendingResetPersonId,
      handleOpenChangePassword,
      handleSendPasswordReset,
    ]
  );

  const userActions: TableAction<IPerson>[] = useMemo(
    () => [
      {
        label: "Editar",
        icon: <FiEdit2 size={16} />,
        onClick: (row) => {
          handleOpenEditUserModal(row);
        },
      },
      {
        label: (row) =>
          isLoggedUserRow(row) ? "Alterar senha" : "Enviar redefinição de senha",
        icon: (row) =>
          isLoggedUserRow(row) ? <RiKey2Line size={16} /> : <RiMailSendLine size={16} />,
        disabled: (row) =>
          !isLoggedUserRow(row) && (!row.user?.email || sendingResetPersonId === row.id),
        onClick: (row) => {
          if (isLoggedUserRow(row)) {
            handleOpenChangePassword(row);
          } else {
            handleSendPasswordReset(row);
          }
        },
      },
      {
        label: "Excluir",
        icon: <RiDeleteBin7Line size={16} />,
        hidden: (row) =>
          persons.length <= 1 || (isSelfProfile && isFixiter) || isLoggedUserRow(row),
        onClick: (row) => {
          handleDeletePerson(row.id);
        },
      },
    ],
    [
      persons.length,
      isSelfProfile,
      isFixiter,
      isLoggedUserRow,
      sendingResetPersonId,
      handleOpenEditUserModal,
      handleOpenChangePassword,
      handleSendPasswordReset,
      handleDeletePerson,
    ]
  );

  // Switch Person Type (Pessoa Física / Pessoa Jurídica)
  const handleSwitchPersonType = (newType: "FISICA" | "JURIDICA") => {
    if (!isEditingRegistration || personType === newType) return;
    setPersonType(newType);
    const snap = registrationSnapshot.current;
    if (snap && snap.personType === newType) {
      setCustomerName(snap.name);
      setCompanyName(snap.companyName);
      setDocumentNumber(snap.documentNumber);
    } else {
      setCustomerName("");
      setCompanyName("");
      setDocumentNumber("");
    }
    setRegistrationErrors({});
  };

  // Busca CEP Endereço Cadastral
  const handleRegCepChange = async (value: string) => {
    const formatted = formatCep(value);
    setRegCep(formatted);
    const cleanCep = value.replace(/\D/g, "");
    if (cleanCep.length === 8 && !searchingRegCep) {
      setSearchingRegCep(true);
      try {
        const response = await apiViaCep.get(`/${cleanCep}/json/`);
        if (response.data && !response.data.erro) {
          if (response.data.logradouro) setRegStreet(response.data.logradouro);
          if (response.data.bairro) setRegDistrict(response.data.bairro);
          if (response.data.localidade) setRegCity(response.data.localidade);
          if (response.data.uf) setRegState(response.data.uf.toUpperCase());
          showToast({
            type: "success",
            message: "Endereço cadastral localizado via CEP!",
          });
        }
      } catch {
        // silent fail
      } finally {
        setSearchingRegCep(false);
      }
    }
  };

  // Busca CEP Endereço Localizador
  const handleLocCepChange = async (value: string) => {
    const formatted = formatCep(value);
    setLocCep(formatted);
    const cleanCep = value.replace(/\D/g, "");
    if (cleanCep.length === 8 && !searchingLocCep) {
      setSearchingLocCep(true);
      try {
        const response = await apiViaCep.get(`/${cleanCep}/json/`);
        if (response.data && !response.data.erro) {
          if (response.data.logradouro) setLocStreet(response.data.logradouro);
          if (response.data.bairro) setLocDistrict(response.data.bairro);
          if (response.data.localidade) setLocCity(response.data.localidade);
          if (response.data.uf) setLocState(response.data.uf.toUpperCase());
          showToast({
            type: "success",
            message: "Endereço do localizador localizado via CEP!",
          });
        }
      } catch {
        // silent fail
      } finally {
        setSearchingLocCep(false);
      }
    }
  };

  // --- BLOCK 1 HANDLERS (DADOS DE FATURAMENTO) ---
  const handleCancelRegistration = () => {
    if (registrationSnapshot.current) {
      const snap = registrationSnapshot.current;
      setCustomerName(snap.name);
      setCompanyName(snap.companyName);
      setPersonType(snap.personType);
      setDocumentNumber(snap.documentNumber);
      setEmail(snap.email);
      setPhone(snap.phone);
      setInstagram(snap.instagram);
      setRegCep(snap.regCep);
      setRegStreet(snap.regStreet);
      setRegNumber(snap.regNumber);
      setRegNoNumber(snap.regNoNumber);
      setRegComplement(snap.regComplement);
      setRegNoComplement(snap.regNoComplement);
      setRegDistrict(snap.regDistrict);
      setRegCity(snap.regCity);
      setRegState(snap.regState);
    }
    setRegistrationErrors({});
    setIsEditingRegistration(false);
  };

  const handleSaveRegistration = async () => {
    if (!id) return;

    const newErrors: {
      customerName?: string;
      companyName?: string;
      documentNumber?: string;
      email?: string;
      phone?: string;
    } = {};
    const rawDoc = documentNumber.replace(/\D/g, "");
    const trimmedEmail = email.trim();
    const rawPhone = phone.replace(/\D/g, "");

    if (personType === "FISICA") {
      if (!customerName.trim()) {
        newErrors.customerName = "Informe o nome completo.";
      }
      if (rawDoc.length !== 11) {
        newErrors.documentNumber = "Informe o CPF completo (11 dígitos).";
      } else if (!isValidCPF(rawDoc)) {
        newErrors.documentNumber = "O CPF informado é inválido.";
      }
    } else {
      if (!customerName.trim()) {
        newErrors.customerName = "Informe a razão social.";
      }
      if (!companyName.trim()) {
        newErrors.companyName = "Informe o nome fantasia.";
      }
      if (rawDoc.length !== 14) {
        newErrors.documentNumber = "Informe o CNPJ completo (14 dígitos).";
      } else if (!isValidCNPJ(rawDoc)) {
        newErrors.documentNumber = "O CNPJ informado é inválido.";
      }
    }

    if (!trimmedEmail) {
      newErrors.email = "Informe o e-mail.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      newErrors.email = "Informe um e-mail válido.";
    }

    if (rawPhone.length < 10) {
      newErrors.phone = "Informe um telefone válido com DDD.";
    }

    if (Object.keys(newErrors).length > 0) {
      setRegistrationErrors(newErrors);
      const firstError =
        newErrors.customerName ||
        newErrors.companyName ||
        newErrors.documentNumber ||
        newErrors.email ||
        newErrors.phone ||
        "Verifique os campos obrigatórios.";
      showToast({
        type: "error",
        message: firstError,
      });
      return;
    }

    setRegistrationErrors({});
    setSavingRegistration(true);
    try {
      const resolvedName = customerName.trim();
      const resolvedCompanyName =
        personType === "JURIDICA" ? companyName.trim() : null;

      const payload: Record<string, any> = {
        name: resolvedName,

        company_name: resolvedCompanyName,
        email: email.trim(),
        person_type: personType,
        document_number: rawDoc,
        phone: phone.replace(/\D/g, ""),
        instagram,
        is_test: isTest,
        city: regCity.trim(),
        state: regState.trim().toUpperCase(),
      };

      await api.patch(`/licensees/${id}`, payload);
      setCustomerName(resolvedName);
      setCompanyName(resolvedCompanyName || "");
      setHeaderDisplayName(
        personType === "JURIDICA"
          ? resolvedCompanyName || resolvedName
          : resolvedName
      );

      // Salvar endereço principal se preenchido (somente billing_address, sem type)
      if (regStreet.trim()) {
        const addressPayload = {
          licensee_id: id,
          cep: regCep.replace(/\D/g, ""),
          address: regStreet,
          number: regNoNumber ? "S/N" : regNumber.trim() || "S/N",
          complement: regNoComplement ? "" : regComplement.trim(),
          district: regDistrict,
          city: regCity.trim(),
          state: regState.trim().toUpperCase(),
          country: "BR",
          billing_address: true,
        };

        if (regAddressId) {
          await api.put(`/address/${regAddressId}`, addressPayload);
        } else {
          const createRes = await api.post("/address", {
            ...addressPayload,
            company_address: useSameAddress,
          });
          if (createRes.data?.id) {
            setRegAddressId(createRes.data.id);
          }
        }

        setCustomerAddressCache(id, {
          city: regCity.trim(),
          state: regState.trim().toUpperCase(),
        });
      }

      registrationSnapshot.current = {
        name: resolvedName,
        companyName: resolvedCompanyName || "",
        personType,
        documentNumber,
        email,
        phone,
        instagram,
        regCep,
        regStreet,
        regNumber,
        regNoNumber,
        regComplement,
        regNoComplement,
        regDistrict,
        regCity,
        regState,
      };

      setIsEditingRegistration(false);
      showToast({
        type: "success",
        message: "Dados de faturamento salvos com sucesso!",
      });
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.message || "Erro ao salvar dados de faturamento.";
      showToast({
        type: "error",
        message: errorMsg,
      });
    } finally {
      setSavingRegistration(false);
    }
  };

  // --- BLOCK 3 HANDLERS (DADOS DO LOCALIZADOR) ---
  const handleUploadLocatorPicture = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!id || !e.target.files || !e.target.files[0]) return;
    const file = e.target.files[0];

    setUploadingLocatorPic(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await api.put(`/licensees/${id}/locator-picture`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const updatedPic =
        response.data?.locator?.picture_link ||
        response.data?.locator_picture_link ||
        response.data?.picture_link;

      if (updatedPic) {
        setLocatorPictureLink(updatedPic);
        if (locatorSnapshot.current) {
          locatorSnapshot.current.pictureLink = updatedPic;
        }
      } else {
        await loadData();
      }

      showToast({
        type: "success",
        message: "Foto do localizador atualizada com sucesso!",
      });
    } catch (err: any) {
      showToast({
        type: "error",
        message:
          err?.response?.data?.message || "Erro ao fazer upload da foto do localizador.",
      });
    } finally {
      setUploadingLocatorPic(false);
      if (locatorFileInputRef.current) {
        locatorFileInputRef.current.value = "";
      }
    }
  };

  const handleRemoveLocatorPicture = async () => {
    if (!id) return;
    if (!window.confirm("Deseja realmente remover a foto do localizador?")) return;

    setRemovingLocatorPic(true);
    try {
      await api.patch(`/licensees/${id}`, {
        locator: {
          picture_link: null,
        },
      });

      setLocatorPictureLink(null);
      if (locatorSnapshot.current) {
        locatorSnapshot.current.pictureLink = null;
      }

      showToast({
        type: "success",
        message: "Foto do localizador removida com sucesso!",
      });
    } catch (err: any) {
      showToast({
        type: "error",
        message:
          err?.response?.data?.message || "Erro ao remover a foto do localizador.",
      });
    } finally {
      setRemovingLocatorPic(false);
    }
  };

  const handleCancelLocator = () => {
    if (locatorSnapshot.current) {
      const snap = locatorSnapshot.current;
      setIsPublic(snap.isPublic);
      setUseSameContact(snap.useSameContact);
      setLocatorName(snap.locatorName);
      setLocatorPhone(snap.locatorPhone);
      setLocatorPictureLink(snap.pictureLink);
      setUseSameAddress(snap.useSameAddress);
      setLocCep(snap.locCep);
      setLocStreet(snap.locStreet);
      setLocNumber(snap.locNumber);
      setLocNoNumber(snap.locNoNumber);
      setLocComplement(snap.locComplement);
      setLocNoComplement(snap.locNoComplement);
      setLocDistrict(snap.locDistrict);
      setLocCity(snap.locCity);
      setLocState(snap.locState);
    }
    setIsEditingLocator(false);
  };

  const handleSaveLocator = async () => {
    if (!id) return;
    setSavingLocator(true);

    try {
      const contactName =
        personType === "JURIDICA" ? (companyName || customerName) : customerName;
      const finalLocName = useSameContact ? contactName : locatorName;
      const finalLocPhone = useSameContact ? phone : locatorPhone;

      const locatorPayload = {
        locator: {
          name: finalLocName,
          phone: finalLocPhone.replace(/\D/g, ""),
          is_public: isPublic,
          use_billing_contact: useSameContact,
          picture_link: locatorPictureLink,
        },
      };

      await api.patch(`/licensees/${id}`, locatorPayload);

      let nextLocCep = locCep;
      let nextLocStreet = locStreet;
      let nextLocNumber = locNumber;
      let nextLocNoNumber = locNoNumber;
      let nextLocComplement = locComplement;
      let nextLocNoComplement = locNoComplement;
      let nextLocDistrict = locDistrict;
      let nextLocCity = locCity;
      let nextLocState = locState;

      // Cenário B: Endereço exclusivo para o Localizador (!useSameAddress)
      if (!useSameAddress && locStreet.trim()) {
        const addressPayload = {
          licensee_id: id,
          cep: locCep.replace(/\D/g, ""),
          address: locStreet,
          number: locNoNumber ? "S/N" : locNumber.trim() || "S/N",
          complement: locNoComplement ? "" : locComplement.trim(),
          district: locDistrict,
          city: locCity,
          state: locState.trim().toUpperCase(),
          country: "BR",
          billing_address: false,
          company_address: true,
        };

        if (locAddressId && locAddressId !== regAddressId) {
          await api.put(`/address/${locAddressId}`, addressPayload);
        } else {
          const createRes = await api.post("/address", addressPayload);
          if (createRes.data?.id) {
            setLocAddressId(createRes.data.id);
          } else {
            const refreshedAddr = await api.get(`/address/all/${id}`);
            if (Array.isArray(refreshedAddr.data)) {
              const createdWorkAddr = refreshedAddr.data.find(
                (a: any) => a.id !== regAddressId && Boolean(a.company_address)
              );
              if (createdWorkAddr?.id) {
                setLocAddressId(createdWorkAddr.id);
              }
            }
          }
        }
      } else if (useSameAddress) {
        // Cenário C: Voltar para "Usar o mesmo endereço de faturamento"
        if (regAddressId) {
          await api.put(`/address/${regAddressId}`, {
            company_address: true,
          });
        }

        setLocAddressId(null);

        nextLocCep = "";
        nextLocStreet = "";
        nextLocNumber = "";
        nextLocNoNumber = false;
        nextLocComplement = "";
        nextLocNoComplement = false;
        nextLocDistrict = "";
        nextLocCity = "";
        nextLocState = "";

        setLocCep("");
        setLocStreet("");
        setLocNumber("");
        setLocNoNumber(false);
        setLocComplement("");
        setLocNoComplement(false);
        setLocDistrict("");
        setLocCity("");
        setLocState("");
      }

      locatorSnapshot.current = {
        isPublic,
        useSameContact,
        locatorName: finalLocName,
        locatorPhone: finalLocPhone,
        pictureLink: locatorPictureLink,
        useSameAddress,
        locCep: nextLocCep,
        locStreet: nextLocStreet,
        locNumber: nextLocNumber,
        locNoNumber: nextLocNoNumber,
        locComplement: nextLocComplement,
        locNoComplement: nextLocNoComplement,
        locDistrict: nextLocDistrict,
        locCity: nextLocCity,
        locState: nextLocState,
      };

      setIsEditingLocator(false);
      showToast({
        type: "success",
        message: "Dados do localizador salvos com sucesso!",
      });
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.message || "Erro ao salvar dados do localizador.";
      showToast({
        type: "error",
        message: errorMsg,
      });
    } finally {
      setSavingLocator(false);
    }
  };

  // --- BLOCK 3 HANDLERS (IMPRESSORAS) ---
  const handleAddPrinter = () => {
    if (!printerToAdd) return;
    const found = allPrinters.find((p) => String(p.value) === String(printerToAdd));
    if (!found) return;

    if (selectedPrinters.some((p) => String(p.value) === String(found.value))) {
      showToast({
        type: "info",
        message: "Esta impressora já está vinculada.",
      });
      return;
    }
    setSelectedPrinters((prev) => [...prev, found]);
    setPrinterToAdd("");
  };

  const handleRemovePrinter = (value: string | number) => {
    setSelectedPrinters((prev) => prev.filter((p) => p.value !== value));
  };

  const handleCancelPrinters = () => {
    setSelectedPrinters(printersSnapshot.current);
    setPrinterToAdd("");
    setIsEditingPrinters(false);
  };

  const handleSavePrinters = async () => {
    if (!id) return;

    setSavingPrinters(true);
    try {
      const printerIds = selectedPrinters.map((p) => p.value);
      await api.patch(`/licensees/${id}`, { printers: printerIds });

      printersSnapshot.current = [...selectedPrinters];
      setIsEditingPrinters(false);
      showToast({
        type: "success",
        message: "Impressoras atualizadas com sucesso!",
      });
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.message || "Erro ao atualizar impressoras.";
      showToast({
        type: "error",
        message: errorMsg,
      });
    } finally {
      setSavingPrinters(false);
    }
  };

  if (loading) {
    return <Loading loading={true} />;
  }

  const availablePrintersToAdd = allPrinters.filter(
    (p) => !selectedPrinters.some((sel) => String(sel.value) === String(p.value))
  );



  interface TabItem {
    id: TabType;
    label: string;
    icon: React.ReactNode;
    badge?: string;
    badgeVariant?: "default" | "neutral" | "success";
    locked?: boolean;
  }

  const tabs: TabItem[] = [
    {
      id: "dados",
      label: "Dados",
      icon: <RiFileList3Line size={18} />,
    },
    {
      id: "locator" as const,
      label: "Localizador",
      icon: <RiCompass3Line size={18} />,
      badge: isPublic ? "Visível" : "Oculto",
      badgeVariant: isPublic ? ("success" as const) : ("neutral" as const),
    },
    ...(canShowCertificateTab
      ? [
          {
            id: "certificado" as const,
            label: "Certificado",
            icon: <RiAwardLine size={18} />,
          },
        ]
      : []),
    {
      id: "assinatura",
      label: "Assinatura",
      icon: <LuFileSignature size={18} />,
    },
    ...(!isSelfProfile && (customerType === "licensees" || !isFixiter)
      ? [
          {
            id: "fixcoins" as const,
            label: "FixCoins",
            icon: <RiMoneyDollarCircleLine size={18} />,
            badge: Number(fixcoinsBalance || 0).toLocaleString("pt-BR"),
            badgeVariant: "default" as const,
          },
        ]
      : []),
    {
      id: "usuarios" as const,
      label: "Usuários",
      icon: <FiUsers size={18} />,
      badge: String(persons.length),
      badgeVariant: "neutral" as const,
    },
    ...(customerType === "licensees" || !isFixiter || isSelfProfile
      ? [
          {
            id: "impressoras" as const,
            label: "Impressoras 3D",
            icon: <RiPrinterLine size={18} />,
            badge: isSelfProfile && isFixiter ? undefined : String(selectedPrinters.length),
            badgeVariant: "neutral" as const,
            locked: Boolean(isSelfProfile && isFixiter),
          },
        ]
      : []),
    ...(!isSelfProfile && isFixiter
      ? [
          {
            id: "provider" as const,
            label: "FixPoint",
            icon: <RiPrinterLine size={18} />,
            badge: providerId ? "Com" : "Sem",
            badgeVariant: providerId
              ? ("success" as const)
              : ("neutral" as const),
          },
        ]
      : []),
  ];

  return (
    <PageContainer>
      <TabsNavWrapper
        ref={tabsNavRef}
        $canScrollLeft={canScrollLeft}
        $canScrollRight={canScrollRight}
        $isDragging={isDragging}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUpOrLeave}
        onMouseLeave={handleMouseUpOrLeave}
      >
        <TabsNavContainer>
          {tabs.map((tab) => (
            <TabNavItem
              key={tab.id}
              type="button"
              data-active={!tab.locked && activeTab === tab.id}
              $active={!tab.locked && activeTab === tab.id}
              onClick={() => {
                if (hasDragged.current) return;
                if (tab.locked) {
                  setLockedTabModal(tab.id);
                  return;
                }
                setActiveTab(tab.id);
                if (isSelfProfile) {
                  navigate(`/profile/${tab.id}`, { replace: true });
                }
              }}
            >
              {tab.icon}
              <span>{tab.label}</span>
              {tab.badge && (
                <TabBadge $variant={tab.badgeVariant}>{tab.badge}</TabBadge>
              )}
              {tab.locked && (
                <LockedFeatureIcon
                  size={24}
                  iconSize={12}
                  open={lockedTabModal === tab.id}
                  onOpenChange={(open) => setLockedTabModal(open ? tab.id : null)}
                />
              )}
            </TabNavItem>
          ))}
        </TabsNavContainer>
      </TabsNavWrapper>

      <FormWrapper>
        {/* BLOCO 1: DADOS DE FATURAMENTO */}
        {activeTab === "dados" && (
          <SectionBlock>
          <SectionHeader>
            <SectionTitleWrapper>
              <SectionTitleRow>
                <RiFileList3Line size={20} color="var(--fixit)" />
                <SectionTitle>Dados de Faturamento</SectionTitle>
                {isEditingRegistration && <EditingBadge>Em Edição</EditingBadge>}
              </SectionTitleRow>
              <SectionSubtitle>
                Informações fiscais, cadastrais e endereço de faturamento.
              </SectionSubtitle>
            </SectionTitleWrapper>

            <BlockHeaderRight>
              {!isSelfProfile && (
                <HeaderToggleWrapper>
                  <HeaderToggleLabel htmlFor="switch-block-is-test">
                    Licenciado Teste
                  </HeaderToggleLabel>
                  <SwitchInput
                    id="switch-block-is-test"
                    name="is_test"
                    text=""
                    checked={isTest}
                    disabled={savingSwitchTest}
                    onChange={(e) => handleToggleTest(e.target.checked)}
                  />
                </HeaderToggleWrapper>
              )}

              {!isEditingRegistration ? (
                <SecondaryButton
                  text="Editar"
                  icon={<FiEdit2 size={14} />}
                  onClick={() => setIsEditingRegistration(true)}
                />
              ) : (
                <>
                  <SecondaryButton
                    text="Cancelar"
                    onClick={handleCancelRegistration}
                    disabled={savingRegistration}
                  />
                  <PrimaryButton
                    text="Salvar"
                    onClick={handleSaveRegistration}
                    disabled={savingRegistration}
                  />
                </>
              )}
            </BlockHeaderRight>
          </SectionHeader>

          {/* SELETOR SEGMENTADO PF / PJ */}
          <PersonTypeSwitchWrapper>
            <SwitchContainer>
              <SwitchButton
                type="button"
                active={personType === "FISICA"}
                disabled={!isEditingRegistration}
                onClick={() => handleSwitchPersonType("FISICA")}
              >
                Pessoa Física
              </SwitchButton>
              <SwitchButton
                type="button"
                active={personType === "JURIDICA"}
                disabled={!isEditingRegistration}
                onClick={() => handleSwitchPersonType("JURIDICA")}
              >
                Pessoa Jurídica
              </SwitchButton>
            </SwitchContainer>
          </PersonTypeSwitchWrapper>

          {/* FORMULÁRIO DADOS CADASTRAIS */}
          <InputGroup>
            {personType === "FISICA" ? (
              <>
                <Row>
                  <FlexInput flex={2}>
                    <OutlinedInput
                      inputName="name"
                      label="Nome Completo"
                      value={customerName}
                      disabled={!isEditingRegistration}
                      error={registrationErrors.customerName}
                      marginOnError
                      handleChange={(val) => {
                        setCustomerName(val);
                        if (registrationErrors.customerName) {
                          setRegistrationErrors((prev) => ({
                            ...prev,
                            customerName: undefined,
                          }));
                        }
                      }}
                    />
                  </FlexInput>

                  <FlexInput flex={1}>
                    <OutlinedInput
                      inputName="document_number"
                      label="CPF"
                      value={documentNumber}
                      disabled={!isEditingRegistration}
                      error={registrationErrors.documentNumber}
                      marginOnError
                      handleChange={(val) => {
                        setDocumentNumber(cpfMask(val));
                        if (registrationErrors.documentNumber) {
                          setRegistrationErrors((prev) => ({
                            ...prev,
                            documentNumber: undefined,
                          }));
                        }
                      }}
                      maxLength={14}
                    />
                  </FlexInput>
                </Row>

                <Row>
                  <FlexInput flex={1.5}>
                    <OutlinedInput
                      inputName="email"
                      label="E-mail"
                      value={email}
                      disabled={!isEditingRegistration}
                      error={registrationErrors.email}
                      marginOnError
                      handleChange={(val) => {
                        setEmail(val);
                        if (registrationErrors.email) {
                          setRegistrationErrors((prev) => ({
                            ...prev,
                            email: undefined,
                          }));
                        }
                      }}
                    />
                  </FlexInput>

                  <FlexInput flex={1}>
                    <OutlinedInput
                      inputName="phone"
                      label="Telefone / WhatsApp"
                      value={phone}
                      disabled={!isEditingRegistration}
                      error={registrationErrors.phone}
                      marginOnError
                      handleChange={(val) => {
                        setPhone(formatPhoneInput(val));
                        if (registrationErrors.phone) {
                          setRegistrationErrors((prev) => ({
                            ...prev,
                            phone: undefined,
                          }));
                        }
                      }}
                      maxLength={15}
                    />
                  </FlexInput>

                  <FlexInput flex={1}>
                    <OutlinedInput
                      inputName="instagram"
                      label="Instagram"
                      value={instagram}
                      disabled={!isEditingRegistration}
                      handleChange={(val) => setInstagram(val)}
                    />
                  </FlexInput>
                </Row>
              </>
            ) : (
              <>
                <Row>
                  <FlexInput flex={2}>
                    <OutlinedInput
                      inputName="name"
                      label="Razão Social"
                      value={customerName}
                      disabled={!isEditingRegistration}
                      error={registrationErrors.customerName}
                      marginOnError
                      handleChange={(val) => {
                        setCustomerName(val);
                        if (registrationErrors.customerName) {
                          setRegistrationErrors((prev) => ({
                            ...prev,
                            customerName: undefined,
                          }));
                        }
                      }}
                    />
                  </FlexInput>

                  <FlexInput flex={1}>
                    <OutlinedInput
                      inputName="document_number"
                      label="CNPJ"
                      value={documentNumber}
                      disabled={!isEditingRegistration}
                      error={registrationErrors.documentNumber}
                      marginOnError
                      handleChange={(val) => {
                        setDocumentNumber(cnpjMask(val));
                        if (registrationErrors.documentNumber) {
                          setRegistrationErrors((prev) => ({
                            ...prev,
                            documentNumber: undefined,
                          }));
                        }
                      }}
                      maxLength={18}
                    />
                  </FlexInput>
                </Row>

                <Row>
                  <FlexInput flex={2}>
                    <OutlinedInput
                      inputName="company_name"
                      label="Nome Fantasia"
                      value={companyName}
                      disabled={!isEditingRegistration}
                      error={registrationErrors.companyName}
                      marginOnError
                      handleChange={(val) => {
                        setCompanyName(val);
                        if (registrationErrors.companyName) {
                          setRegistrationErrors((prev) => ({
                            ...prev,
                            companyName: undefined,
                          }));
                        }
                      }}
                    />
                  </FlexInput>

                  <FlexInput flex={1}>
                    <OutlinedInput
                      inputName="phone"
                      label="Telefone / WhatsApp"
                      value={phone}
                      disabled={!isEditingRegistration}
                      error={registrationErrors.phone}
                      marginOnError
                      handleChange={(val) => {
                        setPhone(formatPhoneInput(val));
                        if (registrationErrors.phone) {
                          setRegistrationErrors((prev) => ({
                            ...prev,
                            phone: undefined,
                          }));
                        }
                      }}
                      maxLength={15}
                    />
                  </FlexInput>
                </Row>

                <Row>
                  <FlexInput flex={1.5}>
                    <OutlinedInput
                      inputName="email"
                      label="E-mail"
                      value={email}
                      disabled={!isEditingRegistration}
                      error={registrationErrors.email}
                      marginOnError
                      handleChange={(val) => {
                        setEmail(val);
                        if (registrationErrors.email) {
                          setRegistrationErrors((prev) => ({
                            ...prev,
                            email: undefined,
                          }));
                        }
                      }}
                    />
                  </FlexInput>

                  <FlexInput flex={1}>
                    <OutlinedInput
                      inputName="instagram"
                      label="Instagram"
                      value={instagram}
                      disabled={!isEditingRegistration}
                      handleChange={(val) => setInstagram(val)}
                    />
                  </FlexInput>
                </Row>
              </>
            )}

            {/* SUBSEÇÃO: ENDEREÇO (FATURAMENTO) - ACORDEÃO COMPACTO */}
            <SubSectionDivider>
              <RiMapPin2Line size={16} color="var(--fixit)" />
              <SubSectionTitle>Endereço</SubSectionTitle>
              <SubSectionLine />
            </SubSectionDivider>

            <AddressSummaryBar
              $isClickable={true}
              onClick={() => setIsRegAddressExpanded((prev) => !prev)}
            >
              <AddressSummaryLeft>
                <AddressSummaryText>
                  {regStreet ? (
                    <>
                      <strong>{regStreet}</strong>
                      {regNoNumber ? ", S/N" : regNumber ? `, ${regNumber}` : ""}
                      {regComplement && !regNoComplement ? ` - ${regComplement}` : ""} •{" "}
                      {regDistrict ? `${regDistrict}, ` : ""}
                      {regCity} - {regState} • CEP {regCep || "Não informado"}
                    </>
                  ) : (
                    "Nenhum endereço de faturamento cadastrado. Clique para preencher."
                  )}
                </AddressSummaryText>
              </AddressSummaryLeft>
              <AddressAccordionToggleBtn
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsRegAddressExpanded((prev) => !prev);
                }}
              >
                {isRegAddressExpanded
                  ? "Recolher endereço"
                  : isEditingRegistration
                  ? "Editar endereço"
                  : "Ver endereço completo"}
                {isRegAddressExpanded ? (
                  <RiArrowUpSLine size={18} />
                ) : (
                  <RiArrowDownSLine size={18} />
                )}
              </AddressAccordionToggleBtn>
            </AddressSummaryBar>

            <AddressFieldsWrapper $isExpanded={isRegAddressExpanded}>
              <Row>
                <FlexInput flex={1}>
                  <OutlinedInput
                    inputName="regCep"
                    label={searchingRegCep ? "Buscando CEP..." : "CEP"}
                    value={regCep}
                    disabled={!isEditingRegistration}
                    handleChange={handleRegCepChange}
                    maxLength={9}
                  />
                </FlexInput>

                <FlexInput flex={3}>
                  <OutlinedInput
                    inputName="regStreet"
                    label="Rua / Logradouro"
                    value={regStreet}
                    disabled={!isEditingRegistration}
                    handleChange={(val) => setRegStreet(val)}
                  />
                </FlexInput>
              </Row>

              <Row>
                <FlexInput flex={1}>
                  <OutlinedInput
                    inputName="regNumber"
                    label="Número"
                    value={regNoNumber ? "S/N" : regNumber}
                    disabled={!isEditingRegistration || regNoNumber}
                    handleChange={(val) => setRegNumber(val)}
                  />
                  <InlineCheckboxLabel>
                    <InlineCheckbox
                      type="checkbox"
                      checked={regNoNumber}
                      disabled={!isEditingRegistration}
                      onChange={(e) => {
                        setRegNoNumber(e.target.checked);
                        if (e.target.checked) setRegNumber("S/N");
                        else setRegNumber("");
                      }}
                    />
                    Não possui número
                  </InlineCheckboxLabel>
                </FlexInput>

                <FlexInput flex={1}>
                  <OutlinedInput
                    inputName="regComplement"
                    label="Complemento"
                    value={regNoComplement ? "Sem complemento" : regComplement}
                    disabled={!isEditingRegistration || regNoComplement}
                    handleChange={(val) => setRegComplement(val)}
                  />
                  <InlineCheckboxLabel>
                    <InlineCheckbox
                      type="checkbox"
                      checked={regNoComplement}
                      disabled={!isEditingRegistration}
                      onChange={(e) => {
                        setRegNoComplement(e.target.checked);
                        if (e.target.checked) setRegComplement("Sem complemento");
                        else setRegComplement("");
                      }}
                    />
                    Sem complemento
                  </InlineCheckboxLabel>
                </FlexInput>
              </Row>

              <Row>
                <FlexInput flex={2}>
                  <OutlinedInput
                    inputName="regDistrict"
                    label="Bairro"
                    value={regDistrict}
                    disabled={!isEditingRegistration}
                    handleChange={(val) => setRegDistrict(val)}
                  />
                </FlexInput>

                <FlexInput flex={2}>
                  <OutlinedInput
                    inputName="regCity"
                    label="Cidade"
                    value={regCity}
                    disabled={!isEditingRegistration}
                    handleChange={(val) => setRegCity(val)}
                  />
                </FlexInput>

                <FlexInput flex={1}>
                  <OutlinedInput
                    inputName="regState"
                    label="UF"
                    value={regState}
                    disabled={!isEditingRegistration}
                    maxLength={2}
                    handleChange={(val) => setRegState(val.toUpperCase())}
                  />
                </FlexInput>
              </Row>
            </AddressFieldsWrapper>
          </InputGroup>
        </SectionBlock>
        )}

        {/* BLOCO: CERTIFICADO */}
        {activeTab === "certificado" && canShowCertificateTab && (
          <SectionBlock>
            <SectionHeader>
              <SectionTitleWrapper>
                <SectionTitleRow>
                  <RiAwardLine size={20} color="var(--fixit)" />
                  <SectionTitle>Certificado</SectionTitle>
                </SectionTitleRow>
                <SectionSubtitle>
                  Visualize e baixe o certificado de conclusão do Curso Órteses Fix it 3D.
                </SectionSubtitle>
              </SectionTitleWrapper>

              {(!isSelfProfile || (hasLinkedCourse && certificateData?.available)) && (
                <BlockHeaderRight>
                  {!isSelfProfile &&
                    (!hasLinkedCourse ? (
                      <PrimaryButton
                        text="Vincular Turma"
                        icon={<FiPlus size={15} />}
                        onClick={handleOpenCourseModal}
                      />
                    ) : (
                      <SecondaryButton
                        text="Editar"
                        icon={<FiEdit2 size={14} />}
                        onClick={handleOpenCourseModal}
                      />
                    ))}

                  {hasLinkedCourse && certificateData?.available && (
                    <>
                      <SecondaryButton
                        text={isDownloadingCertificateImage ? "Gerando..." : "Baixar .jpg"}
                        icon={<FiImage size={15} />}
                        onClick={handleDownloadCertificateImage}
                        disabled={isDownloadingCertificateImage || isDownloadingCertificatePDF}
                      />
                      <PrimaryButton
                        text={isDownloadingCertificatePDF ? "Gerando..." : "Baixar .pdf"}
                        icon={<FiDownload size={15} />}
                        onClick={handleDownloadCertificatePDF}
                        disabled={isDownloadingCertificatePDF || isDownloadingCertificateImage}
                      />
                    </>
                  )}
                </BlockHeaderRight>
              )}
            </SectionHeader>

            {loadingCertificate && !hasLinkedCourse ? (
              <LoadingContainer style={{ padding: "48px 20px" }}>
                <Loading loading={true} />
              </LoadingContainer>
            ) : !hasLinkedCourse ? (
              <EmptyPrintersText>
                Nenhuma turma vinculada a este aluno.
              </EmptyPrintersText>
            ) : (
              <>
                {(Boolean(resolvedLinkedCourse.name) || !isSelfProfile) && (
                  <CertificateClassBar>
                    <CertificateClassInfo>
                      <CertificateClassIconBox>
                        <FiCalendar size={18} />
                      </CertificateClassIconBox>
                      <CertificateClassTextGroup>
                        <CertificateClassLabel>Turma do Treinamento</CertificateClassLabel>
                        <CertificateClassName>
                          <span>{resolvedLinkedCourse.name || "Turma vinculada"}</span>
                          {resolvedLinkedCourse.date &&
                            !String(resolvedLinkedCourse.name || "").includes(
                              safeFormatDatePtBr(resolvedLinkedCourse.date, "___")
                            ) && (
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "var(--gray)",
                                }}
                              >
                                • {safeFormatDatePtBr(resolvedLinkedCourse.date)}
                              </span>
                            )}
                          {resolvedLinkedCourse.duration !== null &&
                            resolvedLinkedCourse.duration !== undefined && (
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: "var(--gray)",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                • <FiClock size={12} /> {resolvedLinkedCourse.duration}h
                              </span>
                            )}
                        </CertificateClassName>
                      </CertificateClassTextGroup>
                    </CertificateClassInfo>
                  </CertificateClassBar>
                )}

                {loadingCertificate ? (
                  <LoadingContainer style={{ padding: "48px 20px" }}>
                    <Loading loading={true} />
                  </LoadingContainer>
                ) : certificateData?.available ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      paddingTop: "8px",
                    }}
                  >
                    <CertificateContainer>
                      <CertificateWrapper ref={certificateRef}>
                        <CertificateBgImage
                          src={CertificateBackground}
                          alt="Certificado Background"
                        />

                        <CertificateOverlayContent>
                          <CertificateParticipantName>
                            {certificateParticipantName}
                          </CertificateParticipantName>

                          <CertificateCourseName>
                            Curso Órteses Fix it 3D
                          </CertificateCourseName>

                          {certificateData.formatted_date && (
                            <CertificateDateText>
                              {certificateData.formatted_date}
                            </CertificateDateText>
                          )}
                          {certificateData.formatted_duration && (
                            <CertificateDurationText>
                              {certificateData.formatted_duration}
                            </CertificateDurationText>
                          )}
                        </CertificateOverlayContent>
                      </CertificateWrapper>
                    </CertificateContainer>
                  </div>
                ) : (
                  <EmptyPrintersText>
                    {String(certificateData?.message || "")
                      .toLowerCase()
                      .includes("nenhuma turma")
                      ? "O certificado estará disponível após a conclusão do treinamento ao vivo."
                      : certificateData?.message ||
                        "O certificado estará disponível após a conclusão do treinamento ao vivo."}
                  </EmptyPrintersText>
                )}
              </>
            )}
          </SectionBlock>
        )}

        {/* BLOCO: ASSINATURA & PLANO */}
        {activeTab === "assinatura" && (
          <SectionBlock>
            <SectionHeader>
              <SectionTitleWrapper>
                <SectionTitleRow>
                  <LuFileSignature size={20} color="var(--fixit)" />
                  <SectionTitle>Assinatura</SectionTitle>
                  {(isEditingSignature || isAddingSignature) && (
                    <EditingBadge>
                      {isAddingSignature ? "Nova Assinatura" : "Em Edição"}
                    </EditingBadge>
                  )}
                </SectionTitleRow>
                <SectionSubtitle>
                  Detalhes do plano contratado, vigência e histórico de assinaturas.
                </SectionSubtitle>
              </SectionTitleWrapper>

              {!isSelfProfile && (
                <BlockHeaderRight>
                  {isEditingSignature || isAddingSignature ? (
                    <>
                      <SecondaryButton
                        text="Cancelar"
                        onClick={handleCancelSignature}
                        disabled={savingSignature}
                      />
                      <PrimaryButton
                        text="Salvar"
                        onClick={handleSaveSignature}
                        disabled={savingSignature}
                      />
                    </>
                  ) : (
                    <>
                      {!currentSignature ? (
                        <PrimaryButton
                          text="Adicionar Assinatura"
                          icon={<FiPlus size={15} />}
                          onClick={handleStartAddSignature}
                        />
                      ) : (
                        <SignatureActionColumn>
                          <SecondaryButton
                            variant="danger"
                            text="Cancelar Assinatura"
                            icon={<MdOutlineCancel size={14} />}
                            onClick={handleCancelCustomer}
                          />
                          <SecondaryButton
                            text="Editar"
                            icon={<FiEdit2 size={14} />}
                            onClick={handleToggleEditSignature}
                          />
                        </SignatureActionColumn>
                      )}
                    </>
                  )}
                </BlockHeaderRight>
              )}
            </SectionHeader>

            <InputGroup>
              {!currentSignature && !isAddingSignature ? (
                <>
                  <EmptySignatureNotice>
                    <EmptySignatureTitle>Nenhuma assinatura ativa</EmptySignatureTitle>
                    <EmptySignatureDescription>
                      Nenhuma assinatura ativa no momento. Consulte os detalhes e planos anteriores no histórico abaixo.
                    </EmptySignatureDescription>
                  </EmptySignatureNotice>

                  <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", marginTop: 8 }}>
                    <HistoryLinkButton
                      type="button"
                      onClick={() => setIsHistoryModalOpen(true)}
                    >
                      <LuHistory size={16} />
                      Ver histórico de assinaturas anteriores {allSignatures.length > 0 ? `(${allSignatures.length})` : ""}
                    </HistoryLinkButton>
                  </div>
                </>
              ) : (
                <>
                  {isAddingSignature && currentSignature && (
                    <WarningNotice>
                      <FiAlertCircle size={20} style={{ flexShrink: 0, marginTop: 2 }} />
                      <div>
                        <strong>Atenção: Substituição de Assinatura</strong>
                        <div style={{ marginTop: 4 }}>
                          Este cliente já possui uma assinatura ativa do plano{" "}
                          <strong>{currentSignature.plan?.plan_name || "Atual"}</strong>. Ao salvar, essa assinatura anterior será encerrada com a data de hoje e arquivada no histórico.
                        </div>
                      </div>
                    </WarningNotice>
                  )}

                  {/* LINHA 1: VIGÊNCIA (DATA DE INÍCIO E ENCERRAMENTO / SEM VALIDADE) */}
                  <Row>
                    <FlexInput flex={1}>
                      <OutlinedInput
                        inputName="signatureStartDate"
                        label="Data de Início"
                        type="date"
                        value={signatureStartDate}
                        disabled={!isEditingSignature && !isAddingSignature}
                        handleChange={(val) => setSignatureStartDate(val)}
                      />
                    </FlexInput>

                    <FlexInput flex={1}>
                      {noExpiration ? (
                        <ExpirationOutlinedContainer isEditing={isEditingSignature || isAddingSignature}>
                          <ExpirationNotchedLabel isEditing={isEditingSignature || isAddingSignature}>
                            Data de Encerramento
                          </ExpirationNotchedLabel>
                          <InlineCheckboxLabel
                            style={{
                              margin: 0,
                              cursor: (isEditingSignature || isAddingSignature) ? "pointer" : "default",
                              width: "100%",
                            }}
                          >
                            <InlineCheckbox
                              type="checkbox"
                              checked={noExpiration}
                              disabled={!isEditingSignature && !isAddingSignature}
                              onChange={(e) => {
                                setNoExpiration(e.target.checked);
                              }}
                            />
                            <span
                              style={{
                                fontSize: 14,
                                fontWeight: 500,
                                color: (isEditingSignature || isAddingSignature) ? "var(--black)" : "var(--dark-gray)",
                              }}
                            >
                              Sem validade (plano contínuo)
                            </span>
                          </InlineCheckboxLabel>
                        </ExpirationOutlinedContainer>
                      ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: 4, width: "100%" }}>
                          <OutlinedInput
                            inputName="signatureEndDate"
                            label="Data de Encerramento"
                            type="date"
                            value={signatureEndDate}
                            disabled={!isEditingSignature && !isAddingSignature}
                            handleChange={(val) => setSignatureEndDate(val)}
                          />
                          {(isEditingSignature || isAddingSignature) && (
                            <InlineCheckboxLabel style={{ margin: "2px 0 0 2px" }}>
                              <InlineCheckbox
                                type="checkbox"
                                checked={noExpiration}
                                onChange={(e) => {
                                  setNoExpiration(e.target.checked);
                                  if (e.target.checked) {
                                    setSignatureEndDate("");
                                  }
                                }}
                              />
                              <span style={{ fontSize: 13, color: "var(--dark-gray)" }}>
                                Sem validade (plano contínuo)
                              </span>
                            </InlineCheckboxLabel>
                          )}
                        </div>
                      )}
                    </FlexInput>
                  </Row>

                  {/* LINHA 2: SELETOR DE PLANO (FORA DA CAIXA) */}
                  <Row>
                    <FlexInput flex={1}>
                      <FloatingSelect
                        label="Plano"
                        value={selectedPlanId}
                        disabled={!isEditingSignature && !isAddingSignature}
                        onChange={(e) => setSelectedPlanId(e.target.value)}
                      >
                        <option value="" disabled hidden>
                          {activePlans.length === 0 ? "Carregando planos..." : "Selecione um plano"}
                        </option>
                        {activePlans.map((plan) => (
                          <option key={plan.id} value={plan.id}>
                            {plan.plan_name}
                          </option>
                        ))}
                      </FloatingSelect>
                    </FlexInput>
                  </Row>

                  {/* LINHA 3: DETALHES DO PLANO NA TABELA PADRÃO DO APP */}
                  {planDetails && (
                    <PlanTableWrapper>
                      <Table
                        columns={planColumns}
                        data={[planDetails]}
                      />
                    </PlanTableWrapper>
                  )}

                  {/* BOTÃO EM FORMATO DE TEXTO: HISTÓRICO DE ASSINATURAS */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", marginTop: 4 }}>
                    <HistoryLinkButton
                      type="button"
                      onClick={() => setIsHistoryModalOpen(true)}
                    >
                      <LuHistory size={16} />
                      Ver histórico de assinaturas anteriores {allSignatures.length > 0 ? `(${allSignatures.length})` : ""}
                    </HistoryLinkButton>
                  </div>
                </>
              )}
            </InputGroup>
          </SectionBlock>
        )}

        {/* BLOCO: FIXCOINS */}
        {activeTab === "fixcoins" && (
          <SectionBlock>
            <SectionHeader>
              <SectionTitleWrapper>
                <SectionTitleRow>
                  <RiMoneyDollarCircleLine size={20} color="var(--fixit)" />
                  <SectionTitle>FixCoins</SectionTitle>
                </SectionTitleRow>
                <SectionSubtitle>
                  Histórico de transações e movimentações financeiras de FixCoins.
                </SectionSubtitle>
              </SectionTitleWrapper>

              <BlockHeaderRight>
                <PrimaryButton
                  text="Adicionar FixCoins"
                  icon={<FiPlus size={15} />}
                  onClick={() => setIsAddFixcoinModalOpen(true)}
                />
              </BlockHeaderRight>
            </SectionHeader>

            <Transactions
              key={fixcoinsReloadKey}
              licenseeId={id}
              hideNavigationAction={true}
              onSuccess={fetchFixcoinsBalance}
            />
          </SectionBlock>
        )}

        {/* BLOCO 2: USUÁRIOS (DADOS DO PERSON DO LICENSEE) */}
        {activeTab === "usuarios" && (
        <SectionBlock>
          <SectionHeader>
            <SectionTitleWrapper>
              <SectionTitleRow>
                <FiUsers size={20} color="var(--fixit)" />
                <SectionTitle>Usuários</SectionTitle>
              </SectionTitleRow>
              <SectionSubtitle>
                Gerencie os usuários e acessos vinculados à conta.
              </SectionSubtitle>
            </SectionTitleWrapper>

            {!(isSelfProfile && isFixiter) && (
              <BlockHeaderRight>
                <PrimaryButton
                  text="Novo Usuário"
                  icon={<FiPlus size={15} />}
                  onClick={handleOpenNewUserModal}
                />
              </BlockHeaderRight>
            )}
          </SectionHeader>

          {persons.length === 0 ? (
            <EmptyUsersContainer>
              <FiUsers size={32} color="#b0b0b0" />
              <EmptyUsersText>
                Nenhum usuário vinculado no momento.
              </EmptyUsersText>
              {!(isSelfProfile && isFixiter) && (
                <SecondaryButton
                  text="Adicionar Primeiro Usuário"
                  icon={<FiPlus size={14} />}
                  onClick={handleOpenNewUserModal}
                />
              )}
            </EmptyUsersContainer>
          ) : (
            <UsersTableWrapper>
              <Table
                columns={userColumns}
                data={sortedPersons}
                actions={userActions}
                onRowClick={handleOpenEditUserModal}
              />
            </UsersTableWrapper>
          )}
        </SectionBlock>
        )}

        {/* BLOCO 3: DADOS DO LOCALIZADOR */}
        {activeTab === "locator" && (
        <SectionBlock>
          <SectionHeader>
            <SectionTitleWrapper>
              <SectionTitleRow>
                <RiCompass3Line size={20} color="var(--fixit)" />
                <SectionTitle>Dados do Localizador</SectionTitle>
                {isEditingLocator && <EditingBadge>Em Edição</EditingBadge>}
              </SectionTitleRow>
              <SectionSubtitle>
                Configure as informações visíveis no mapa e diretório de profissionais e clínicas.
              </SectionSubtitle>
            </SectionTitleWrapper>

            <BlockHeaderRight>
              <HeaderToggleWrapper>
                <HeaderToggleLabel htmlFor="switch-block-is-public">
                  Visível
                </HeaderToggleLabel>
                <SwitchInput
                  id="switch-block-is-public"
                  name="is_public"
                  text=""
                  checked={isPublic}
                  disabled={savingSwitchPublic}
                  onChange={(e) => handleTogglePublic(e.target.checked)}
                />
              </HeaderToggleWrapper>

              {!isEditingLocator ? (
                <SecondaryButton
                  text="Editar"
                  icon={<FiEdit2 size={14} />}
                  onClick={() => setIsEditingLocator(true)}
                />
              ) : (
                <>
                  <SecondaryButton
                    text="Cancelar"
                    onClick={handleCancelLocator}
                    disabled={savingLocator}
                  />
                  <PrimaryButton
                    text="Salvar"
                    onClick={handleSaveLocator}
                    loading={savingLocator}
                    disabled={savingLocator}
                  />
                </>
              )}
            </BlockHeaderRight>
          </SectionHeader>

          {/* Foto do Localizador + Estrela Oficial */}
          <LocatorPhotoSection>
            <input
              type="file"
              ref={locatorFileInputRef}
              style={{ display: "none" }}
              accept="image/*"
              onChange={handleUploadLocatorPicture}
            />
            <LocatorPhotoPreview>
              <img
                src={getLocatorPictureUrl(locatorPictureLink) || logoImage}
                alt="Foto do Localizador"
              />
              <LocatorOfficialStarBadge $isGold={!isFixiter}>
                <FaStar size={14} />
              </LocatorOfficialStarBadge>
            </LocatorPhotoPreview>

            <LocatorPhotoInfo>
              <LocatorPhotoText>
                <span className="photo-title">Foto de Exibição</span>
                <span className="photo-subtitle">
                  Perfis com foto transmitem mais credibilidade e recebem mais contatos. Adicione um retrato profissional com boa iluminação ou a logo oficial da clínica.
                </span>
              </LocatorPhotoText>

              <LocatorPhotoActions>
                <LocatorPhotoUploadBtn
                  type="button"
                  disabled={uploadingLocatorPic || removingLocatorPic}
                  onClick={() => locatorFileInputRef.current?.click()}
                >
                  <RiUpload2Line size={14} />
                  {uploadingLocatorPic
                    ? "Enviando..."
                    : locatorPictureLink
                    ? "Alterar foto"
                    : "Adicionar foto"}
                </LocatorPhotoUploadBtn>

                {locatorPictureLink && (
                  <LocatorPhotoDeleteBtn
                    type="button"
                    disabled={uploadingLocatorPic || removingLocatorPic}
                    onClick={handleRemoveLocatorPicture}
                  >
                    <RiDeleteBin7Line size={14} />
                    {removingLocatorPic ? "Removendo..." : "Remover foto"}
                  </LocatorPhotoDeleteBtn>
                )}
              </LocatorPhotoActions>
            </LocatorPhotoInfo>
          </LocatorPhotoSection>

          {/* Classificação de Estrelas no Localizador (Estrela do usuário sempre primeiro + Seta apontando para a estrela da foto) */}
          <LocatorStarsGrid>
            {(isFixiter
              ? (["silver", "gold"] as const)
              : (["gold", "silver"] as const)
            ).map((tier, idx) =>
              tier === "silver" ? (
                <LocatorStarCard
                  key="silver"
                  $tier="silver"
                  $active={isFixiter}
                  $hasTopArrow={idx === 0}
                >
                  <LocatorStarIconBox $tier="silver">
                    <FaStar size={14} />
                  </LocatorStarIconBox>

                  <LocatorStarTitleTextWrapper>
                    <LocatorStarHeader>
                      <LocatorStarTitleGroup>
                        <LocatorStarTitle>Estrela Prateada</LocatorStarTitle>
                      </LocatorStarTitleGroup>

                      {isFixiter && (
                        <LocatorStarStatusBadge $variant="silver-active">
                          <RiStarFill size={11} />
                          Estrela Atual
                        </LocatorStarStatusBadge>
                      )}
                    </LocatorStarHeader>

                    <LocatorStarDescription>
                      Aparece no Localizador em um <strong>raio de até 500km</strong>.
                    </LocatorStarDescription>
                  </LocatorStarTitleTextWrapper>
                </LocatorStarCard>
              ) : (
                <LocatorStarCard
                  key="gold"
                  $tier="gold"
                  $active={!isFixiter}
                  $locked={isFixiter}
                  $hasTopArrow={idx === 0}
                  onClick={() => {
                    if (isFixiter) {
                      setIsGoldStarModalOpen(true);
                    }
                  }}
                >
                  <LocatorStarIconBox $tier="gold" $locked={isFixiter}>
                    <FaStar size={14} />
                  </LocatorStarIconBox>

                  <LocatorStarTitleTextWrapper>
                    <LocatorStarHeader>
                      <LocatorStarTitleGroup>
                        <LocatorStarTitle>Estrela Dourada</LocatorStarTitle>
                      </LocatorStarTitleGroup>

                      {!isFixiter && (
                        <LocatorStarStatusBadge $variant="gold-active">
                          <RiStarFill size={11} />
                          Estrela Atual
                        </LocatorStarStatusBadge>
                      )}
                    </LocatorStarHeader>

                    <LocatorStarDescription $locked={isFixiter}>
                      Aparece no Localizador em um <strong>raio de até 500km</strong> e tem{" "}
                      <strong>prioridade</strong>, aparecendo <strong>sempre no topo</strong>{" "}
                      antes da Estrela Prateada.
                    </LocatorStarDescription>
                  </LocatorStarTitleTextWrapper>

                  {isFixiter && (
                    <LockedFeatureIcon
                      open={isGoldStarModalOpen}
                      onOpenChange={setIsGoldStarModalOpen}
                    />
                  )}
                </LocatorStarCard>
              )
            )}
          </LocatorStarsGrid>

          <InputGroup>
            <FormCheckboxRow>
              <InlineCheckboxLabel>
                <InlineCheckbox
                  type="checkbox"
                  checked={useSameContact}
                  disabled={!isEditingLocator}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setUseSameContact(checked);
                    if (checked) {
                      setLocatorName(personType === "JURIDICA" ? (companyName || customerName) : customerName);
                      setLocatorPhone(phone);
                    }
                  }}
                />
                Usar os mesmos dados de contato do faturamento ({personType === "JURIDICA" ? "Nome Fantasia e Telefone" : "Nome e Telefone"})
              </InlineCheckboxLabel>
            </FormCheckboxRow>

            <Row>
              <FlexInput flex={2}>
                <OutlinedInput
                  inputName="locatorName"
                  label="Nome de exibição"
                  value={useSameContact ? (personType === "JURIDICA" ? (companyName || customerName) : customerName) : locatorName}
                  disabled={!isEditingLocator || useSameContact}
                  handleChange={(val) => setLocatorName(val)}
                />
              </FlexInput>

              <FlexInput flex={1}>
                <OutlinedInput
                  inputName="locatorPhone"
                  label="Telefone de atendimento"
                  value={useSameContact ? phone : locatorPhone}
                  disabled={!isEditingLocator || useSameContact}
                  handleChange={(val) => setLocatorPhone(formatPhoneInput(val))}
                  maxLength={15}
                />
              </FlexInput>
            </Row>

            <FormCheckboxRow>
              <InlineCheckboxLabel>
                <InlineCheckbox
                  type="checkbox"
                  checked={useSameAddress}
                  disabled={!isEditingLocator}
                  onChange={(e) => setUseSameAddress(e.target.checked)}
                />
                Usar o mesmo endereço de faturamento
              </InlineCheckboxLabel>
            </FormCheckboxRow>

            {useSameAddress ? (
              <AddressPreviewBox>
                <AddressPreviewText>
                  {regStreet ? (
                    <>
                      <strong>Endereço vinculado:</strong> {regStreet}
                      {regNoNumber ? ", S/N" : regNumber ? `, ${regNumber}` : ""}
                      {regComplement && !regNoComplement ? ` - ${regComplement}` : ""} •{" "}
                      {regDistrict ? `${regDistrict}, ` : ""}
                      {regCity} - {regState} • CEP {regCep || "Não informado"}
                    </>
                  ) : (
                    "Nenhum endereço de faturamento cadastrado. Preencha o endereço no bloco de Dados de Faturamento ou desmarque a opção acima para cadastrar um endereço exclusivo."
                  )}
                </AddressPreviewText>
              </AddressPreviewBox>
            ) : (
              <>
                <Row>
                  <FlexInput flex={1}>
                    <OutlinedInput
                      inputName="locCep"
                      label={searchingLocCep ? "Buscando CEP..." : "CEP"}
                      value={locCep}
                      disabled={!isEditingLocator}
                      handleChange={handleLocCepChange}
                      maxLength={9}
                    />
                  </FlexInput>

                  <FlexInput flex={3}>
                    <OutlinedInput
                      inputName="locStreet"
                      label="Rua / Logradouro"
                      value={locStreet}
                      disabled={!isEditingLocator}
                      handleChange={(val) => setLocStreet(val)}
                    />
                  </FlexInput>
                </Row>

                <Row>
                  <FlexInput flex={1}>
                    <OutlinedInput
                      inputName="locNumber"
                      label="Número"
                      value={locNoNumber ? "S/N" : locNumber}
                      disabled={!isEditingLocator || locNoNumber}
                      handleChange={(val) => setLocNumber(val)}
                    />
                    <InlineCheckboxLabel>
                      <InlineCheckbox
                        type="checkbox"
                        checked={locNoNumber}
                        disabled={!isEditingLocator}
                        onChange={(e) => {
                          setLocNoNumber(e.target.checked);
                          if (e.target.checked) setLocNumber("S/N");
                          else setLocNumber("");
                        }}
                      />
                      Não possui número
                    </InlineCheckboxLabel>
                  </FlexInput>

                  <FlexInput flex={1}>
                    <OutlinedInput
                      inputName="locComplement"
                      label="Complemento"
                      value={locNoComplement ? "Sem complemento" : locComplement}
                      disabled={!isEditingLocator || locNoComplement}
                      handleChange={(val) => setLocComplement(val)}
                    />
                    <InlineCheckboxLabel>
                      <InlineCheckbox
                        type="checkbox"
                        checked={locNoComplement}
                        disabled={!isEditingLocator}
                        onChange={(e) => {
                          setLocNoComplement(e.target.checked);
                          if (e.target.checked) setLocComplement("Sem complemento");
                          else setLocComplement("");
                        }}
                      />
                      Sem complemento
                    </InlineCheckboxLabel>
                  </FlexInput>
                </Row>

                <Row>
                  <FlexInput flex={2}>
                    <OutlinedInput
                      inputName="locDistrict"
                      label="Bairro"
                      value={locDistrict}
                      disabled={!isEditingLocator}
                      handleChange={(val) => setLocDistrict(val)}
                    />
                  </FlexInput>

                  <FlexInput flex={2}>
                    <OutlinedInput
                      inputName="locCity"
                      label="Cidade"
                      value={locCity}
                      disabled={!isEditingLocator}
                      handleChange={(val) => setLocCity(val)}
                    />
                  </FlexInput>

                  <FlexInput flex={1}>
                    <OutlinedInput
                      inputName="locState"
                      label="UF"
                      value={locState}
                      disabled={!isEditingLocator}
                      maxLength={2}
                      handleChange={(val) => setLocState(val.toUpperCase())}
                    />
                  </FlexInput>
                </Row>
              </>
            )}
          </InputGroup>
        </SectionBlock>
        )}

        {/* BLOCO 4: IMPRESSORAS VINCULADAS */}
        {activeTab === "impressoras" && (
        <SectionBlock style={{ position: "relative", overflow: "hidden" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              width: "100%",
              ...(isSelfProfile && isFixiter
                ? {
                    filter: "blur(4px)",
                    opacity: 0.35,
                    pointerEvents: "none",
                    userSelect: "none",
                  }
                : {}),
            }}
          >
            <SectionHeader>
              <SectionTitleWrapper>
                <SectionTitleRow>
                  <RiPrinterLine size={20} color="var(--fixit)" />
                  <SectionTitle>Impressoras Selecionadas</SectionTitle>
                  {isEditingPrinters && <EditingBadge>Em Edição</EditingBadge>}
                </SectionTitleRow>
                <SectionSubtitle>
                  Relação de impressoras 3D vinculadas.
                </SectionSubtitle>
              </SectionTitleWrapper>

              {!isSelfProfile && (
                <BlockHeaderRight>
                  {!isEditingPrinters ? (
                    <SecondaryButton
                      text="Editar"
                      icon={<FiEdit2 size={14} />}
                      onClick={() => setIsEditingPrinters(true)}
                    />
                  ) : (
                    <>
                      <SecondaryButton
                        text="Cancelar"
                        onClick={handleCancelPrinters}
                        disabled={savingPrinters}
                      />
                      <PrimaryButton
                        text="Salvar"
                        onClick={handleSavePrinters}
                        loading={savingPrinters}
                        disabled={savingPrinters}
                      />
                    </>
                  )}
                </BlockHeaderRight>
              )}
            </SectionHeader>

            <PrintersContainer>
              {isEditingPrinters && (
                <PrinterAddRow>
                  <PrinterAddInputWrapper>
                    <FloatingSelect
                      label="Adicionar Impressora"
                      value={printerToAdd}
                      onChange={(e) => setPrinterToAdd(e.target.value)}
                    >
                      <option value="" disabled hidden></option>
                      {availablePrintersToAdd.map((p) => (
                        <option key={String(p.value)} value={String(p.value)}>
                          {p.optionText}
                        </option>
                      ))}
                    </FloatingSelect>
                  </PrinterAddInputWrapper>

                  <PrimaryButton
                    text="Adicionar"
                    showPlusIcon
                    onClick={handleAddPrinter}
                    disabled={!printerToAdd}
                  />
                </PrinterAddRow>
              )}

              <SelectedPrintersList>
                {selectedPrinters.length === 0 ? (
                  <EmptyPrintersText>
                    Nenhuma impressora 3D vinculada no momento.
                  </EmptyPrintersText>
                ) : (
                  selectedPrinters.map((printer) => (
                    <PrinterChip key={String(printer.value)}>
                      <PrinterChipName>{printer.optionText}</PrinterChipName>
                      {isEditingPrinters && (
                        <RemovePrinterButton
                          type="button"
                          title="Remover impressora"
                          onClick={() => handleRemovePrinter(printer.value)}
                        >
                          <RiDeleteBin7Line size={16} />
                        </RemovePrinterButton>
                      )}
                    </PrinterChip>
                  ))
                )}
              </SelectedPrintersList>
            </PrintersContainer>
          </div>

          {isSelfProfile && isFixiter && <LockedFeatureIcon withOverlay />}
        </SectionBlock>
        )}

        {/* BLOCO 5: FIXPOINT (PROVEDOR) (EXCLUSIVO FIXITER) */}
        {activeTab === "provider" && (
          <SectionBlock>
            <SectionHeader>
              <SectionTitleWrapper>
                <SectionTitleRow>
                  <RiPrinterLine size={20} color="var(--fixit)" />
                  <SectionTitle>FixPoint (Provedor)</SectionTitle>
                  {isEditingProvider && <EditingBadge>Em Edição</EditingBadge>}
                </SectionTitleRow>
                <SectionSubtitle>
                  Defina o centro de impressão 3D responsável por produzir os pedidos.
                </SectionSubtitle>
              </SectionTitleWrapper>

              <BlockHeaderRight>
                {!isEditingProvider ? (
                  <SecondaryButton
                    text="Editar"
                    icon={<FiEdit2 size={14} />}
                    onClick={() => setIsEditingProvider(true)}
                  />
                ) : (
                  <>
                    <SecondaryButton
                      text="Cancelar"
                      onClick={handleCancelProvider}
                      disabled={savingProvider}
                    />
                    <PrimaryButton
                      text="Salvar"
                      onClick={handleSaveProvider}
                      loading={savingProvider}
                      disabled={savingProvider}
                    />
                  </>
                )}
              </BlockHeaderRight>
            </SectionHeader>

            <InputGroup>
              {isEditingProvider && (
                <ProviderSearchWrapper ref={providerSuggestionsRef}>
                  <ProviderSearchContainer>
                    {providerId && selectedProviderInfo ? (
                      <ProviderSelectedFilterBadge>
                        <SelectedFilterTag>
                          <SelectedFilterRemoveButton
                            type="button"
                            onClick={handleClearProvider}
                            title="Remover FixPoint vinculado"
                          >
                            <RiCloseFill />
                          </SelectedFilterRemoveButton>
                          <SelectedFilterText>
                            {getLicenseeDisplayName(
                              selectedProviderInfo,
                              "Licenciado"
                            )}
                          </SelectedFilterText>
                        </SelectedFilterTag>
                      </ProviderSelectedFilterBadge>
                    ) : (
                      <ProviderSearchInput
                        type="text"
                        placeholder="Procurar licenciado..."
                        value={providerSearchTerm}
                        $hasText={!!providerSearchTerm.trim()}
                        onFocus={() => {
                          if (providerSearchTerm.trim().length >= 2) {
                            setShowProviderSuggestions(true);
                          }
                        }}
                        onChange={(e) => {
                          setProviderSearchTerm(e.target.value);
                          setShowProviderSuggestions(true);
                        }}
                      />
                    )}
                    <ProviderSearchButton type="button">
                      <RiSearchLine />
                    </ProviderSearchButton>
                  </ProviderSearchContainer>

                  {showProviderSuggestions &&
                    !providerId &&
                    providerSuggestions.length > 0 && (
                      <ProviderSearchSuggestionsList>
                        {providerSuggestions.map((suggestion) => {
                          const rawDoc = String(
                            suggestion.document_number ||
                              suggestion.documentNumber ||
                              ""
                          ).replace(/\D/g, "");
                          const formattedDoc = rawDoc
                            ? rawDoc.length <= 11
                              ? cpfMask(rawDoc)
                              : cnpjMask(rawDoc)
                            : "";
                          const suggestionName = getLicenseeDisplayName(
                            suggestion,
                            "Licenciado"
                          );
                          return (
                            <ProviderSearchSuggestionItem
                              key={String(suggestion.id)}
                              onClick={() =>
                                handleSelectProviderSuggestion(suggestion)
                              }
                            >
                              {`${suggestionName}${
                                formattedDoc ? ` - ${formattedDoc}` : ""
                              }`}
                            </ProviderSearchSuggestionItem>
                          );
                        })}
                      </ProviderSearchSuggestionsList>
                    )}
                </ProviderSearchWrapper>
              )}

              {selectedProviderInfo ? (
                <PlanTableWrapper>
                  <Table
                    columns={providerColumns}
                    data={[selectedProviderInfo]}
                  />
                </PlanTableWrapper>
              ) : (
                <EmptyPrintersText>
                  Nenhum FixPoint (Provedor) vinculado. Este Fixiter poderá visualizar o catálogo de soluções, mas não poderá emitir pedidos de produção até que um licenciado FixPoint seja associado.
                </EmptyPrintersText>
              )}
            </InputGroup>
          </SectionBlock>
        )}
      </FormWrapper>

      {/* MODAL DE USUÁRIO (CRIAÇÃO / EDIÇÃO DE PERSON) */}
      <FormModal
        open={isUserModalOpen}
        onRequestClose={() => setIsUserModalOpen(false)}
        title={editingPerson ? "Editar Usuário" : "Novo Usuário"}
        subtitle="Informe os dados e atribuições do usuário"
        width={600}
        onSave={handleSavePersonModal}
        onCancel={() => setIsUserModalOpen(false)}
        saveText="Salvar"
        cancelText="Cancelar"
        isSaveLoading={savingPerson}
      >
        <ModalFormWrapper>
          <Row>
            <FlexInput flex={1}>
              <OutlinedInput
                inputName="modalPersonName"
                label="Nome Completo"
                value={modalPersonName}
                handleChange={(val) => setModalPersonName(val)}
              />
            </FlexInput>
          </Row>

          <Row>
            <FlexInput flex={1.5}>
              <OutlinedInput
                inputName="modalPersonEmail"
                label="E-mail"
                value={modalPersonEmail}
                handleChange={(val) => setModalPersonEmail(val)}
              />
            </FlexInput>

            <FlexInput flex={1}>
              <OutlinedInput
                inputName="modalPersonCellphone"
                label="Celular / WhatsApp"
                value={modalPersonCellphone}
                handleChange={(val) => setModalPersonCellphone(formatPhoneInput(val))}
                maxLength={15}
              />
            </FlexInput>
          </Row>

          <Row>
            <FlexInput flex={1.5}>
              <FloatingSelect
                label="Formação Profissional"
                value={modalPersonExpertise}
                onChange={(e) => setModalPersonExpertise(e.target.value)}
              >
                <option value="" disabled hidden></option>
                <option value="Fisioterapeuta">Fisioterapeuta</option>
                <option value="Médico Ortopedista">Médico Ortopedista</option>
                <option value="Médico Reumatologista">Médico Reumatologista</option>
                <option value="Técnico em Imobilização">Técnico em Imobilização</option>
                <option value="Terapeuta Ocupacional">Terapeuta Ocupacional</option>
                <option value="Outro">Outro</option>
              </FloatingSelect>
            </FlexInput>

            <FlexInput flex={1}>
              <OutlinedInput
                inputName="modalPersonCouncilNumber"
                label={
                  modalPersonExpertise === "Técnico em Imobilização"
                    ? "Nº Registro (Opcional)"
                    : "Nº do Conselho / Registro"
                }
                value={modalPersonCouncilNumber}
                handleChange={(val) => setModalPersonCouncilNumber(val)}
              />
            </FlexInput>
          </Row>
        </ModalFormWrapper>
      </FormModal>

      {/* MODAL DE HISTÓRICO DE ASSINATURAS */}
      <FormModal
        open={isHistoryModalOpen}
        onRequestClose={() => setIsHistoryModalOpen(false)}
        title="Histórico de Assinaturas"
        subtitle="Relação de assinaturas e vigências registradas"
        width={720}
        onCancel={() => setIsHistoryModalOpen(false)}
        cancelText="Fechar"
        hideSaveButton
      >
        {allSignatures.length === 0 ? (
          <EmptyUsersContainer>
            <LuHistory size={32} color="#b0b0b0" />
            <EmptyUsersText>
              Nenhuma assinatura encontrada no histórico.
            </EmptyUsersText>
          </EmptyUsersContainer>
        ) : (
          <UsersTableWrapper>
            <Table
              columns={signatureHistoryColumns}
              data={allSignatures}
            />
          </UsersTableWrapper>
        )}
      </FormModal>

      {/* MODAL DE ADICIONAR FIXCOINS */}
      {isAddFixcoinModalOpen && (
        <AddFixcoinModal
          open={isAddFixcoinModalOpen}
          licensee_id={id || ""}
          customerName={headerDisplayName || customerName || companyName}
          onHandleCloseRequest={() => setIsAddFixcoinModalOpen(false)}
          onSuccess={handleFixcoinAdded}
        />
      )}



      {/* MODAL DE CONFIRMAÇÃO DE CANCELAMENTO DE ASSINATURA */}
      <FormModal
        open={isCancelModalOpen}
        onRequestClose={() => {
          if (!isCancellingSubscription) {
            setIsCancelModalOpen(false);
            setCancelConfirmationText("");
          }
        }}
        title="Cancelar Assinatura"
        subtitle="Confirmação de cancelamento de assinatura / contrato"
        width={560}
        onSave={handleConfirmCancelSubscription}
        onCancel={() => {
          setIsCancelModalOpen(false);
          setCancelConfirmationText("");
        }}
        saveText="Cancelar Assinatura"
        cancelText="Voltar"
        isSaveLoading={isCancellingSubscription}
        isSaveDisabled={cancelConfirmationText.trim().toLowerCase() !== "cancelar"}
      >
        <ModalFormWrapper>
          <DangerDeleteNotice>
            <FiAlertTriangle size={20} style={{ flexShrink: 0, marginTop: 2 }} />
            <div>
              <strong>Atenção: Cancelamento de Assinatura</strong>
              <div style={{ marginTop: 4 }}>
                Você está prestes a cancelar a assinatura do plano{" "}
                <strong>{currentSignature?.plan?.plan_name || activePlan?.plan_name || "Plano"}</strong>
                {currentSignature?.created_at
                  ? ` (início em ${safeFormatDatePtBr(currentSignature.created_at, "—")})`
                  : ""}{" "}
                de <strong>{headerDisplayName || customerName || companyName || "—"}</strong>. A assinatura será interrompida imediatamente.
              </div>
            </div>
          </DangerDeleteNotice>

          <p style={{ fontSize: 14, color: "var(--dark-gray)", marginBottom: 12 }}>
            Para confirmar o cancelamento, digite{" "}
            <strong style={{ color: "#ef4444" }}>Cancelar</strong> no campo abaixo:
          </p>

          <Row>
            <FlexInput flex={1}>
              <OutlinedInput
                inputName="cancelConfirmationText"
                label="Digite Cancelar para confirmar"
                placeholder="Cancelar"
                value={cancelConfirmationText}
                handleChange={(val) => setCancelConfirmationText(val)}
                disabled={isCancellingSubscription}
              />
            </FlexInput>
          </Row>
        </ModalFormWrapper>
      </FormModal>

      {/* MODAL DE CONFIRMAÇÃO DE EXCLUSÃO DE ASSINATURA */}
      <FormModal
        open={Boolean(signatureToDelete)}
        onRequestClose={() => {
          if (!isDeletingSignature) {
            setSignatureToDelete(null);
            setDeleteConfirmationText("");
          }
        }}
        title="Excluir Registro de Assinatura"
        subtitle="Confirmação de exclusão física permanente do banco de dados"
        width={560}
        onSave={handleConfirmDeleteSignature}
        onCancel={() => {
          setSignatureToDelete(null);
          setDeleteConfirmationText("");
        }}
        saveText="Excluir Registro"
        cancelText="Cancelar"
        isSaveLoading={isDeletingSignature}
        isSaveDisabled={deleteConfirmationText.trim().toLowerCase() !== "excluir"}
      >
        <ModalFormWrapper>
          <DangerDeleteNotice>
            <FiAlertTriangle size={20} style={{ flexShrink: 0, marginTop: 2 }} />
            <div>
              <strong>Atenção: Ação Irreversível</strong>
              <div style={{ marginTop: 4 }}>
                Você está prestes a excluir permanentemente a assinatura do plano{" "}
                <strong>{signatureToDelete?.plan?.plan_name || "Plano"}</strong> (início em{" "}
                {safeFormatDatePtBr(signatureToDelete?.created_at, "—")}) de{" "}
                <strong>{headerDisplayName || customerName || companyName || "—"}</strong>. Esse registro não poderá ser recuperado.
              </div>
            </div>
          </DangerDeleteNotice>

          <p style={{ fontSize: 14, color: "var(--dark-gray)", marginBottom: 12 }}>
            Para confirmar a exclusão física do registro, digite{" "}
            <strong style={{ color: "#ef4444" }}>Excluir</strong> no campo abaixo:
          </p>

          <Row>
            <FlexInput flex={1}>
              <OutlinedInput
                inputName="deleteConfirmationText"
                label="Digite Excluir para confirmar"
                placeholder="Excluir"
                value={deleteConfirmationText}
                handleChange={(val) => setDeleteConfirmationText(val)}
                disabled={isDeletingSignature}
              />
            </FlexInput>
          </Row>
        </ModalFormWrapper>
      </FormModal>

      {/* MODAL DE VÍNCULO / ALTERAÇÃO DE TURMA DO FIXITER (ADMIN) */}
      <FormModal
        open={isCourseModalOpen}
        onRequestClose={() => {
          if (!savingCourseLink) {
            setIsCourseModalOpen(false);
          }
        }}
        title={
          resolvedLinkedCourse.id || resolvedLinkedCourse.name
            ? "Alterar Turma"
            : "Vincular Turma"
        }
        subtitle="Selecione a turma de treinamento para vincular ao Fixiter e emitir o certificado."
        width={520}
        onSave={handleSaveCourseLink}
        onCancel={() => setIsCourseModalOpen(false)}
        saveText="Salvar Turma"
        cancelText="Cancelar"
        isSaveLoading={savingCourseLink}
        isSaveDisabled={!selectedCourseId || loadingCourses}
      >
        <ModalFormWrapper>
          <Row>
            <FlexInput flex={1}>
              <FloatingSelect
                label="Turma *"
                value={selectedCourseId}
                onChange={(e) => setSelectedCourseId(e.target.value)}
                disabled={loadingCourses || savingCourseLink}
              >
                <option value="">
                  {loadingCourses ? "Carregando turmas..." : "Selecione uma turma"}
                </option>
                {availableCourses.map((course: any) => {
                  const durationLabel =
                    course.duration_hours !== null &&
                    course.duration_hours !== undefined
                      ? ` (${course.duration_hours}h)`
                      : "";
                  return (
                    <option key={course.id} value={course.id}>
                      {course.name}
                      {durationLabel}
                    </option>
                  );
                })}
              </FloatingSelect>
            </FlexInput>
          </Row>
        </ModalFormWrapper>
      </FormModal>

      {/* MODAL DE ALTERAÇÃO DE SENHA DO USUÁRIO LOGADO */}
      <ChangePasswordPopup
        user_id={changePasswordUserId || user?.id || ""}
        open={isChangePasswordOpen}
        setOpen={setIsChangePasswordOpen}
      />
    </PageContainer>
  );
}
